{
  "/assets/lesson-science-cells-nuclei.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-cells-with-and-without-nuclei-0498c4a3.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-cells-with-and-without-nuclei",
      "lessonRevision": 3,
      "presentationSHA256": "06a9cf3530ebb703fdd883590938c03af9180c749f6fa1fc6e9e0d481df2fe52"
    }
  },
  "/assets/lesson-science-animal-plant.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-structures-inside-living-cells-76d047dc.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-structures-inside-living-cells",
      "lessonRevision": 3,
      "presentationSHA256": "d68c76fd947c680271507ae78d992a3b174e4e54461a442b73618530f180809b"
    }
  },
  "/assets/lesson-science-dna-antiparallel.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-reading-dna-and-rna-structures-751ca5aa.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-reading-dna-and-rna-structures",
      "lessonRevision": 3,
      "presentationSHA256": "a4c07d5c48e7ad4cc0540205fc9ff5bd7b9e33fef1fafcdd9777ad512b60929c"
    }
  },
  "/assets/lesson-science-chromosome-packaging.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-packaging-inherited-information-ddff28ee.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-packaging-inherited-information",
      "lessonRevision": 3,
      "presentationSHA256": "b198cefd5375546da41def2bef154a673ce929e73e039e400f9823a95d3457c9"
    }
  },
  "/assets/lesson-science-osmosis.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-water-crossing-selective-membranes-d7babb77.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-water-crossing-selective-membranes",
      "lessonRevision": 3,
      "presentationSHA256": "ee4ed1f32eec3e795853637962e0412a4303cc6d8cb874f5cbe235d390c99ee6"
    }
  },
  "/assets/lesson-science-mitosis.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-making-matching-body-cells-383d73e9.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-making-matching-body-cells",
      "lessonRevision": 3,
      "presentationSHA256": "3590ba1f0497ee6479c4519687383b2fe6cfbac9a6510eadcbd84610c99274fc"
    }
  },
  "/assets/lesson-science-specialisation-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-cells-adapted-for-jobs-5ea5ad1a.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-cells-adapted-for-jobs",
      "lessonRevision": 3,
      "presentationSHA256": "eceaf7b6c1250c32f38692c22d610de8b4fde6ad198c0521a5f0d16676c7b53a"
    }
  },
  "/assets/lesson-science-microscopy-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-seeing-beyond-unaided-eyesight-865684f2.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-seeing-beyond-unaided-eyesight",
      "lessonRevision": 3,
      "presentationSHA256": "ad1be119710e7ba6f8c8da6e087530a553b65bcf4674fa9d540046d300c105c2"
    }
  },
  "/assets/lesson-science-diffusion-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-particles-spreading-across-gradients-5459c058.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-particles-spreading-across-gradients",
      "lessonRevision": 3,
      "presentationSHA256": "b85c21f6f0e2971d1f0773be6c1320d53af22ec6b3c3da11bc193c48b528f274"
    }
  },
  "/assets/lesson-science-differentiation-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-how-cells-acquire-roles-88ce4538.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-how-cells-acquire-roles",
      "lessonRevision": 3,
      "presentationSHA256": "d882c0597d9ae1d16fd44cbf6196ef56e4d07334c121e2470f18f0b87886ab5a"
    }
  },
  "/assets/lesson-science-stem-cells-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-cells-with-developmental-potential-3dc6cb23.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-cells-with-developmental-potential",
      "lessonRevision": 3,
      "presentationSHA256": "ee6183568ba1a2abe24990c5db46903675eb7c217e732f8383638b3f510edd45"
    }
  },
  "/assets/lesson-science-active-transport-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-transport-requiring-cellular-energy-af92c2ed.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-transport-requiring-cellular-energy",
      "lessonRevision": 3,
      "presentationSHA256": "3267390493de96816c6bd11cc867b35390d2e414dfa068cfa6a4df09bb9d97fd"
    }
  },
  "/assets/lesson-science-photosynthesis-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-turning-light-into-chemical-stores-74a81639.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-turning-light-into-chemical-stores",
      "lessonRevision": 3,
      "presentationSHA256": "e1e1cf2ec84e40be3d7798842f7aa2a4f656f5bc23ded0ba09d64a4506a8488d"
    }
  },
  "/assets/lesson-science-respiration-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-releasing-energy-with-and-without-oxygen-ce4b970b.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-releasing-energy-with-and-without-oxygen",
      "lessonRevision": 4,
      "presentationSHA256": "34248c1ec84d2998c93cd83125c4bff5255633d424f821ecd21bc80647470199"
    }
  },
  "/assets/lesson-science-materials-cycles-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-recycling-substances-through-nature-4cd0327f.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-recycling-substances-through-nature",
      "lessonRevision": 4,
      "presentationSHA256": "c6d6722beda093d092c1b2407177857d2e6f528a54d670c3731fdefcf9279672"
    }
  },
  "/assets/lesson-science-protein-structure-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-from-amino-acid-sequence-to-protein-shape-fe206630.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-from-amino-acid-sequence-to-protein-shape",
      "lessonRevision": 3,
      "presentationSHA256": "2fd37dd14f7f3891339744c8f7d714b50af1fb7c4c4872d14757800fd2aa3dcc"
    }
  },
  "/assets/lesson-science-fluid-mosaic-v3.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-membranes-control-traffic-85b4c174.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-membranes-control-traffic",
      "lessonRevision": 4,
      "presentationSHA256": "d35f32be74e913512e67711ce3d981a2c260cf62e70d29dd229e2233269b4e4a"
    }
  },
  "/assets/lesson-science-cholinergic-synapse-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-synapses-transform-one-signal-into-another-af04f964.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-synapses-transform-one-signal-into-another",
      "lessonRevision": 4,
      "presentationSHA256": "35920afc8b844ed385adba567e4c92bb5033abdad3bd37110ce4d106e3e4dbea"
    }
  },
  "/assets/lesson-a-level-biology-building-and-breaking-biological-chains-9b674c09.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-building-and-breaking-biological-chains-f5cd56cc.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-building-and-breaking-biological-chains",
      "lessonRevision": 3,
      "presentationSHA256": "0503ba70e33a2542f0112b8f8c8a5b316e3bfe91ece953237e660671144e8ff4"
    }
  },
  "/assets/lesson-a-level-biology-why-carbohydrate-structure-matters-9db94849.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-why-carbohydrate-structure-matters-cfa17ac9.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-why-carbohydrate-structure-matters",
      "lessonRevision": 3,
      "presentationSHA256": "2103c60097f499159c88c72c681bbd8a171e35f68d0f82327c0afaf69c8b8a73"
    }
  },
  "/assets/lesson-a-level-biology-two-lipid-structures-different-jobs-e8db8bee.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-two-lipid-structures-different-jobs-cb474832.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-two-lipid-structures-different-jobs",
      "lessonRevision": 3,
      "presentationSHA256": "a39fff79af0f4c3c9ec804c48982274bd219ca06f6dccc6a3d716a549a120ec3"
    }
  },
  "/assets/lesson-a-level-biology-enzymes-change-reaction-rates-487167b9.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-enzymes-change-reaction-rates-6cecbf74.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-enzymes-change-reaction-rates",
      "lessonRevision": 3,
      "presentationSHA256": "fd56dbccf5eafd39719a173f163015ae13bb2f026d4f111882dd8b37b162d3df"
    }
  },
  "/assets/lesson-a-level-biology-copying-dna-with-templates-d8570850.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-copying-dna-with-templates-42bbedc1.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-copying-dna-with-templates",
      "lessonRevision": 3,
      "presentationSHA256": "f84eb98e4e3fbbcecfe7b9a6b17504144c938f852517e150fd3fc701b60c5c49"
    }
  },
  "/assets/lesson-a-level-biology-atp-couples-cellular-reactions-b990dad3.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-atp-couples-cellular-reactions-0242ef79.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-atp-couples-cellular-reactions",
      "lessonRevision": 3,
      "presentationSHA256": "a7f1dff139117fd1089312cb67748b222bb1ca6d4f012dcbb16423607170aa6a"
    }
  },
  "/assets/lesson-a-level-biology-water-makes-a-biological-environment-38b441b2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-water-makes-a-biological-environment-1f7eb19c.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-water-makes-a-biological-environment",
      "lessonRevision": 3,
      "presentationSHA256": "ad2ece3eb7a6475f5aba77f5d6999a2adb7bfa8a9bc5f44f941a0a6f44cf1cbe"
    }
  },
  "/assets/lesson-a-level-biology-ions-have-specific-cellular-roles-3300e043.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-ions-have-specific-cellular-roles-bf48e9c5.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-ions-have-specific-cellular-roles",
      "lessonRevision": 3,
      "presentationSHA256": "fa03dd907730b55f274ab2d1455970e9e663ede059d5761368ca278da0a1fea8"
    }
  },
  "/assets/lesson-a-level-biology-cell-compartments-divide-the-work-21f31f6d.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-cell-compartments-divide-the-work-b839bd5d.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-cell-compartments-divide-the-work",
      "lessonRevision": 4,
      "presentationSHA256": "b6a1c61735d3e79a3207f516db0587594757002d9b7024d8016d3c5a4e9afdb4"
    }
  },
  "/assets/lesson-a-level-biology-bacteria-are-cells-viruses-are-particles-29758f0e.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-bacteria-are-cells-viruses-are-particles-98580fb0.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-bacteria-are-cells-viruses-are-particles",
      "lessonRevision": 4,
      "presentationSHA256": "6a964d47817198b0e6c7e53c71f25c9eba8e26c4e155b9db5224a7d61d38ba70"
    }
  },
  "/assets/lesson-a-level-biology-microscopes-reveal-different-kinds-of-detail-eed3387b.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-microscopes-reveal-different-kinds-of-detail-916b6d4b.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-microscopes-reveal-different-kinds-of-detail",
      "lessonRevision": 4,
      "presentationSHA256": "b9bac7757412b7cadbbfdc1f5bae0ee0f34686a0497fe87a7bf6950f2d801ed9"
    }
  },
  "/assets/lesson-a-level-biology-making-cells-without-changing-the-chromosome-count-1c128eb7.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-making-cells-without-changing-the-chromosome-count-3d1287d0.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-making-cells-without-changing-the-chromosome-count",
      "lessonRevision": 4,
      "presentationSHA256": "179aaa4781c7cad6b1cfd44bd2f55015ee2ce4dc112976b7d34ddd1e27833519"
    }
  },
  "/assets/lesson-a-level-biology-recognition-defence-and-immune-memory-f32b2f74.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-recognition-defence-and-immune-memory-b74c4631.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-recognition-defence-and-immune-memory",
      "lessonRevision": 4,
      "presentationSHA256": "cf6c7fae8c73d72de122b8a76773432fe7cfccfcb2024cac5adb59116dc73037"
    }
  },
  "/assets/lesson-a-level-biology-size-changes-the-exchange-problem-223e6d60.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-size-changes-the-exchange-problem-17ff19c0.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-size-changes-the-exchange-problem",
      "lessonRevision": 4,
      "presentationSHA256": "257d73d106ecf0cbff7e7824650ded791cea00567ad1b144f07c1a0a59d64de0"
    }
  },
  "/assets/lesson-a-level-biology-keeping-respiratory-gases-moving-7c5c6cc5.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-keeping-respiratory-gases-moving-bdf1c0d2.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-keeping-respiratory-gases-moving",
      "lessonRevision": 4,
      "presentationSHA256": "c8f59c4dfbe07132df93de63da646fa31d437af36f86257fdf7e65036f70e249"
    }
  },
  "/assets/lesson-a-level-biology-digestion-prepares-molecules-for-absorption-578050a2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-digestion-prepares-molecules-for-absorption-843722b9.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-digestion-prepares-molecules-for-absorption",
      "lessonRevision": 4,
      "presentationSHA256": "d0743af6076b4470cfd4507647b42c2e6db2468d7524766d5d9872efba1c3993"
    }
  },
  "/assets/lesson-a-level-biology-blood-transport-links-distant-tissues-eb4be36f.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-blood-transport-links-distant-tissues-f59a6007.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-blood-transport-links-distant-tissues",
      "lessonRevision": 4,
      "presentationSHA256": "3637d696812954376e338f7f8ff6541d798f22369265c7428e773a5a83280c5c"
    }
  },
  "/assets/lesson-a-level-biology-plants-move-water-and-assimilates-differently-07c6532d.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-plants-move-water-and-assimilates-differently-b92a2d31.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-plants-move-water-and-assimilates-differently",
      "lessonRevision": 4,
      "presentationSHA256": "3df930078dc76bcad5379c7f28c72e56a197ae5ebb2359ef3693ec0674cfdaef"
    }
  },
  "/assets/lesson-a-level-biology-genes-are-instructions-within-organised-dna-79c758d5.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-genes-are-instructions-within-organised-dna-29c62888.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-genes-are-instructions-within-organised-dna",
      "lessonRevision": 4,
      "presentationSHA256": "66ce499419540067462050b517e1e169f8f862624d8d4e465da51e03b508a0f2"
    }
  },
  "/assets/lesson-a-level-biology-from-dna-instructions-to-a-protein-11e6de98.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-from-dna-instructions-to-a-protein-3383a2b6.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-from-dna-instructions-to-a-protein",
      "lessonRevision": 4,
      "presentationSHA256": "e38c8390db93a4e8fb83fb465046e2f2df12bbf146f0e52b0601dab558f0b985"
    }
  },
  "/assets/lesson-a-level-biology-why-offspring-inherit-different-combinations-a432d76f.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-why-offspring-inherit-different-combinations-d316ed68.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-why-offspring-inherit-different-combinations",
      "lessonRevision": 4,
      "presentationSHA256": "91333256f269a41cd4544990b6cadcc388bf98509ac820545551e34370f31d3b"
    }
  },
  "/assets/lesson-biology-natural-selection-v3.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-selection-changes-populations-over-generations-e56f48c0.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-selection-changes-populations-over-generations",
      "lessonRevision": 4,
      "presentationSHA256": "0810316f29e1561b351e09503de1fda47d0a1af2ea3437c653278218ad244b6a"
    }
  },
  "/assets/lesson-science-al-biology-classification-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-classification-is-a-testable-account-of-relationships-cd7219de.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-classification-is-a-testable-account-of-relationships",
      "lessonRevision": 4,
      "presentationSHA256": "2468773c71d5697400f2305ee962f0e7d891dc1931fe112ea0630ade7fcc26ca"
    }
  },
  "/assets/lesson-science-al-biology-biodiversity-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-biodiversity-includes-abundance-as-well-as-richness-18e62fb5.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-biodiversity-includes-abundance-as-well-as-richness",
      "lessonRevision": 4,
      "presentationSHA256": "605850e5572e8046a64380eb673f25208a399b079b6baf4452660c9c8d374e5d"
    }
  },
  "/assets/lesson-science-al-biology-sampling-v3.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-compare-variation-with-fair-sampling-e239d940.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-compare-variation-with-fair-sampling",
      "lessonRevision": 4,
      "presentationSHA256": "cc71f730fda1baf79f8589608421a427c5d13a3275542e4e11faa0b4eb1e0f4a"
    }
  },
  "/assets/lesson-science-al-biology-photosynthesis-v3.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-photosynthesis-links-light-reactions-to-carbon-fixation-2d5f9923.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-photosynthesis-links-light-reactions-to-carbon-fixation",
      "lessonRevision": 3,
      "presentationSHA256": "3119a793104b9590ab39f519dcdaafd729bb9b4d532c9afd0d49506b1b02526f"
    }
  },
  "/assets/lesson-science-al-biology-respiration-v4.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-respiration-transfers-energy-through-linked-reactions-b189b40a.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-respiration-transfers-energy-through-linked-reactions",
      "lessonRevision": 3,
      "presentationSHA256": "370580ffaa7f985516d53d58d2152e435fe434bc6c9fa1e9e5accd98e1da6295"
    }
  },
  "/assets/lesson-science-al-biology-trophic-energy-v3.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-energy-budgets-explain-trophic-transfer-45cffd13.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-energy-budgets-explain-trophic-transfer",
      "lessonRevision": 4,
      "presentationSHA256": "649a184edc8fdf91cd0481ff5041672f043dd05a45ffca3ad4475fd165871c36"
    }
  },
  "/assets/lesson-science-al-biology-nitrogen-cycle-v3.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-microorganisms-help-recycle-nutrients-579337a5.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-microorganisms-help-recycle-nutrients",
      "lessonRevision": 4,
      "presentationSHA256": "8b0408144fd7cf5e1ed8dd6b6b75c7f9346d34dc239b74be28e68d1ec8c82806"
    }
  },
  "/assets/lesson-science-al-biology-stimulus-response-v3.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-responses-connect-a-stimulus-to-survival-11405678.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-responses-connect-a-stimulus-to-survival",
      "lessonRevision": 4,
      "presentationSHA256": "900837d4b69e925f0a2544ee49ee4d46de831aa0f4fd0a3215e0558804e23519"
    }
  },
  "/assets/lesson-science-al-biology-receptors-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-receptors-convert-changes-into-signals-4f3c5221.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-receptors-convert-changes-into-signals",
      "lessonRevision": 4,
      "presentationSHA256": "f1b578b9c21e9db91796d28967b27b268ca3b94cc0dbb588d60ce86f67eb07bc"
    }
  },
  "/assets/lesson-science-al-biology-heart-rhythm-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-the-heart-has-a-rhythm-that-can-be-adjusted-77cf038a.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-the-heart-has-a-rhythm-that-can-be-adjusted",
      "lessonRevision": 4,
      "presentationSHA256": "40517c8294b8cc92196bb537c6f8272723b8e35c964f9f0c735ed6dd1c05ac8c"
    }
  },
  "/assets/lesson-science-al-biology-action-potential-v3.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-an-action-potential-is-a-travelling-membrane-change-89ca9c06.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-an-action-potential-is-a-travelling-membrane-change",
      "lessonRevision": 4,
      "presentationSHA256": "3c9ab5ff3e508602a6531ff7c9e9006f974d754eca7f83247adad3ee5af45561"
    }
  },
  "/assets/lesson-science-al-biology-sliding-filaments-v7.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-muscles-contract-by-sliding-filaments-d6c974a8.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-muscles-contract-by-sliding-filaments",
      "lessonRevision": 4,
      "presentationSHA256": "ad40ed68e9820d6b53f034a10ec28db1e2811d1ae783b50b28e844e268341d23"
    }
  },
  "/assets/lesson-science-al-biology-negative-feedback-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-negative-feedback-stabilises-internal-conditions-e8f0d8ff.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-negative-feedback-stabilises-internal-conditions",
      "lessonRevision": 4,
      "presentationSHA256": "1fb5538a01d34b2e6c1522db9bf3a3e89f0ac31d48460d04b1c384257d1fb948"
    }
  },
  "/assets/lesson-science-al-biology-blood-glucose-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-hormones-coordinate-blood-glucose-regulation-4dd52aa9.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-hormones-coordinate-blood-glucose-regulation",
      "lessonRevision": 4,
      "presentationSHA256": "360597a59adf131a6617b08eafe55ffe4cb183f4955275828e52cf9e4a836bc2"
    }
  },
  "/assets/lesson-science-al-biology-kidney-adh-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-kidneys-balance-water-and-dissolved-substances-ec54340a.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-kidneys-balance-water-and-dissolved-substances",
      "lessonRevision": 4,
      "presentationSHA256": "0904c8ee8b80acaa687c76bc7170d407266e0f94ab793703e265cbbd31fef184"
    }
  },
  "/assets/lesson-science-al-biology-inheritance-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-inheritance-models-predict-probabilities-351f11ff.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-inheritance-models-predict-probabilities",
      "lessonRevision": 4,
      "presentationSHA256": "b4ae7c832aeada133e79bc56f705c6a1989f5caffd982b1867124687b4998437"
    }
  },
  "/assets/lesson-science-al-biology-allele-frequencies-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-allele-frequencies-describe-populations-c4c5ac35.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-allele-frequencies-describe-populations",
      "lessonRevision": 4,
      "presentationSHA256": "a3c84d1f69d4bed6b04dff0dcfe52bc6f832d836aa72cf293d9395e77c6a3f64"
    }
  },
  "/assets/lesson-science-al-biology-speciation-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-reproductive-isolation-can-lead-to-speciation-0d19dd72.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-reproductive-isolation-can-lead-to-speciation",
      "lessonRevision": 4,
      "presentationSHA256": "6f72ce410814e7c835ecd33bd33a789f0058c767632fe8d569cdcd7739664746"
    }
  },
  "/assets/lesson-science-al-biology-ecosystem-populations-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-populations-change-within-interacting-habitats-86c894f1.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-populations-change-within-interacting-habitats",
      "lessonRevision": 4,
      "presentationSHA256": "a8881f11eb268889e8dd132fe5471bed9f55faa910d623e6450ec4f197e1a01c"
    }
  },
  "/assets/lesson-a-level-biology-mutations-have-different-consequences-e5517422.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-mutations-have-different-consequences-d80a5418.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-mutations-have-different-consequences",
      "lessonRevision": 4,
      "presentationSHA256": "9a1b92687ef5a080ae682655bd336479afc8fd2308a6924731421698910e8312"
    }
  },
  "/assets/lesson-a-level-biology-stem-cell-potential-changes-during-differentiation-58a1aa90.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-stem-cell-potential-changes-during-differentiation-b5943a7a.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-stem-cell-potential-changes-during-differentiation",
      "lessonRevision": 4,
      "presentationSHA256": "fcd54d492d5af0c2edd5ca23ca066ee66fda45df8220f495a0716b6228abe232"
    }
  },
  "/assets/lesson-a-level-biology-gene-expression-is-controlled-at-several-stages-e806b9a7.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-gene-expression-is-controlled-at-several-stages-bf4fba5e.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-gene-expression-is-controlled-at-several-stages",
      "lessonRevision": 4,
      "presentationSHA256": "d525c4c9c026631aeb5c9edfaf04be319055120ec8811cf4f6940de2a5098e4e"
    }
  },
  "/assets/lesson-a-level-biology-disrupted-growth-regulation-can-contribute-to-cancer-d7c849dc.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-disrupted-growth-regulation-can-contribute-to-cancer-4f857891.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-disrupted-growth-regulation-can-contribute-to-cancer",
      "lessonRevision": 4,
      "presentationSHA256": "980fc6625d1ccbd62308a4b8f0db02478de692265d827f56c0ada772a342ec03"
    }
  },
  "/assets/lesson-a-level-biology-a-genome-sequence-is-a-starting-point-15c98c08.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-a-genome-sequence-is-a-starting-point-f06b99ba.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-a-genome-sequence-is-a-starting-point",
      "lessonRevision": 4,
      "presentationSHA256": "cd466ed4d72fda0b9a8624b4e6aca2fb41740e057e1acce60b86b6af2eb12fcb"
    }
  },
  "/assets/lesson-a-level-biology-recombinant-dna-combines-biological-instructions-90055018.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-recombinant-dna-combines-biological-instructions-7ec9d8fc.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-recombinant-dna-combines-biological-instructions",
      "lessonRevision": 4,
      "presentationSHA256": "7955e049435b9a9d558831c5389e8b07030b6174828599016237791761d8ad9e"
    }
  },
  "/assets/lesson-a-level-biology-dna-probes-detect-complementary-sequences-ccee15b7.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-dna-probes-detect-complementary-sequences-67199577.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-dna-probes-detect-complementary-sequences",
      "lessonRevision": 4,
      "presentationSHA256": "530ba5149fd9d0874a11bddd7b98590b39bf205d1f4ec8eaac614ebd7eedf87c"
    }
  },
  "/assets/lesson-a-level-biology-dna-profiles-compare-variable-regions-db561820.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-dna-profiles-compare-variable-regions-6a4afbc9.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-dna-profiles-compare-variable-regions",
      "lessonRevision": 4,
      "presentationSHA256": "18540b8660309d003a9f6295301a12736575b7a991894e04dc4c49a5a8abc030"
    }
  },
  "/assets/lesson-science-al-biology-rp-1-7-c.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-distinguishing-initial-rate-from-average-rate-63edd452.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-distinguishing-initial-rate-from-average-rate",
      "lessonRevision": 3,
      "presentationSHA256": "fc020e1d1129bc575676c2c32f437c4bc265fa9af922fdf50e3f01ab87a8167d"
    }
  },
  "/assets/lesson-science-al-biology-rp-2-7-c.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-using-a-mitotic-index-with-clear-counting-rules-5acaaa23.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-using-a-mitotic-index-with-clear-counting-rules",
      "lessonRevision": 3,
      "presentationSHA256": "d64b8cfeb96fc3fe4ee7ce2aa770c7d581de0af48683c2862f4c74517e2df9e9"
    }
  },
  "/assets/lesson-science-al-biology-rp-3-7-c.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-estimating-tissue-water-potential-from-calibration-data-d632232c.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-estimating-tissue-water-potential-from-calibration-data",
      "lessonRevision": 3,
      "presentationSHA256": "3d0133b928c08afd31e4ae21d094009f0321807bfd1e6e5fabc348ace83efed1"
    }
  },
  "/assets/lesson-science-al-biology-rp-4-7-c.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-interpreting-pigment-leakage-through-membranes-5cf74920.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-interpreting-pigment-leakage-through-membranes",
      "lessonRevision": 3,
      "presentationSHA256": "d4667655f74beb674756a1f5df6f7d03003c6301b05e8a58b68e4c5a2670e251"
    }
  },
  "/assets/lesson-science-al-biology-rp-5-7-c.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-connecting-observed-organ-structure-with-function-2971abf6.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-connecting-observed-organ-structure-with-function",
      "lessonRevision": 3,
      "presentationSHA256": "7cfff660995ace96b0149423c1da3a04713d39b3dd062586ddbc9a8c361f9f82"
    }
  },
  "/assets/lesson-science-al-biology-rp-6-7-c.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-separating-antimicrobial-effect-from-diffusion-b78e0984.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-separating-antimicrobial-effect-from-diffusion",
      "lessonRevision": 3,
      "presentationSHA256": "a4d7e1f4a287db5b3680ee96c58363f23fa05c00dbc2565efbb04fffc57eea75"
    }
  },
  "/assets/lesson-science-al-biology-rp-7-7-c.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-comparing-pigments-with-chromatography-4b1cc6b5.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-comparing-pigments-with-chromatography",
      "lessonRevision": 3,
      "presentationSHA256": "c754329de640b64de1cb6da4849209d6a0ddfc79ba214be3f3724cfcb344205e"
    }
  },
  "/assets/lesson-science-al-biology-rp-8-7-c.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-using-an-indicator-to-compare-chloroplast-activity-0a072fb0.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-using-an-indicator-to-compare-chloroplast-activity",
      "lessonRevision": 3,
      "presentationSHA256": "3a1e22c3b1a38f745a4d0853558c7381168b40f2a975504ae72f01118ac0d441"
    }
  },
  "/assets/lesson-science-al-biology-rp-9-7-c.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-defining-what-a-respiration-assay-measures-84c6b198.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-defining-what-a-respiration-assay-measures",
      "lessonRevision": 3,
      "presentationSHA256": "59a5fb8f38da0bf786b7d1eb38281fa216d5aa603a55f4e4e345bdc88bb1bd7b"
    }
  },
  "/assets/lesson-science-al-biology-rp-10-7-c.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-interpreting-an-animal-movement-comparison-8e048769.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-interpreting-an-animal-movement-comparison",
      "lessonRevision": 3,
      "presentationSHA256": "9e868ff3e4961ce039b390482c3d0fc224d88879295f178aac1ec206e4a01b40"
    }
  },
  "/assets/lesson-science-al-biology-rp-11-7-c.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-reading-a-glucose-calibration-with-dilution-cb0b44be.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-reading-a-glucose-calibration-with-dilution",
      "lessonRevision": 3,
      "presentationSHA256": "289c6be293b47717193620617aae11d3cf727eda8c1817f40fac2a3e3c789378"
    }
  },
  "/assets/lesson-science-al-biology-rp-12-7-c.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-a-level-biology-relating-species-distribution-to-a-measured-gradient-f49d4e22.svg",
      "courseId": "uk-a-level-biology",
      "lessonId": "uk-a-level-biology-relating-species-distribution-to-a-measured-gradient",
      "lessonRevision": 3,
      "presentationSHA256": "6b9fcebf11ef20404e1e431426da1a1bbafdf71e6f301eacac7b594abf1db0bc"
    }
  },
  "/assets/lesson-gcse-biology-making-targeted-antibody-tools-fca5866a.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-making-targeted-antibody-tools-0932ce00.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-making-targeted-antibody-tools",
      "lessonRevision": 3,
      "presentationSHA256": "26ee5fb7465433cd368e16f8bd0d797fc847daab18304a723529f7a425436eae"
    }
  },
  "/assets/lesson-gcse-biology-applications-of-targeted-antibodies-757bef31.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-applications-of-targeted-antibodies-3e76cdaa.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-applications-of-targeted-antibodies",
      "lessonRevision": 4,
      "presentationSHA256": "37d2f82032c99c8209adc67cefbd37431aefad8d7c499511b4cc4bb56e50a469"
    }
  },
  "/assets/lesson-gcse-biology-recognising-illness-in-plants-29039a9f.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-recognising-illness-in-plants-4f4cca55.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-recognising-illness-in-plants",
      "lessonRevision": 3,
      "presentationSHA256": "59dd253b2c118e9f36fb09a8d77aa481dd58674e5b4587604467f20d834930bc"
    }
  },
  "/assets/lesson-gcse-biology-how-plants-resist-attack-dde17f4a.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-how-plants-resist-attack-602e44c8.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-how-plants-resist-attack",
      "lessonRevision": 3,
      "presentationSHA256": "4bec9817aa9d132c89e0cbc815d202c65c8eeeae8b00d6d473810a46729cbc40"
    }
  },
  "/assets/lesson-gcse-biology-what-limits-photosynthetic-speed-c721f887.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-what-limits-photosynthetic-speed-1799d600.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-what-limits-photosynthetic-speed",
      "lessonRevision": 3,
      "presentationSHA256": "877c240c2b89c418daa358b0e4895a648923465882273772dba35857b6c29b28"
    }
  },
  "/assets/lesson-gcse-biology-where-plant-sugars-go-1b977d7d.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-where-plant-sugars-go-d7b7a764.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-where-plant-sugars-go",
      "lessonRevision": 3,
      "presentationSHA256": "155b96eede5f97716eff6e5c397e110008721c890093949937c6c48b5cb9694c"
    }
  },
  "/assets/lesson-gcse-biology-growing-microbes-safely-f3a2e69e.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-growing-microbes-safely-6556ceb6.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-growing-microbes-safely",
      "lessonRevision": 3,
      "presentationSHA256": "02997b4320dfbeb11d69332d833b0bb2a75e0f055af5ce2b07b9ea40af878e62"
    }
  },
  "/assets/lesson-gcse-biology-from-cells-to-organisms-94e5b4f4.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-from-cells-to-organisms-1833750a.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-from-cells-to-organisms",
      "lessonRevision": 3,
      "presentationSHA256": "0dbe0ca28b2eca266243b83ec135d39cfa9b8af677427e0e8d9082ff8d738825"
    }
  },
  "/assets/lesson-science-digestion-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-breaking-down-food-27195e31.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-breaking-down-food",
      "lessonRevision": 3,
      "presentationSHA256": "b36b37dbe79809e4977b00201d3fbc9383d2435ba796600ef0b37c85c4848a4f"
    }
  },
  "/assets/lesson-science-double-circulation-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-pumping-and-distributing-blood-b6f53514.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-pumping-and-distributing-blood",
      "lessonRevision": 3,
      "presentationSHA256": "ba3b9cd64db891ddd83fe2901fbc9ffccc2f15a46094897ef3b1706faac76c70"
    }
  },
  "/assets/lesson-gcse-biology-blood-components-and-jobs-55dfac4a.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-blood-components-and-jobs-a7219852.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-blood-components-and-jobs",
      "lessonRevision": 3,
      "presentationSHA256": "08861b844807469064a3804dcae752af4c1354c9a3d92a49d5dfb442658b95c9"
    }
  },
  "/assets/lesson-gcse-biology-when-coronary-vessels-narrow-0ca0f906.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-when-coronary-vessels-narrow-7e55c269.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-when-coronary-vessels-narrow",
      "lessonRevision": 3,
      "presentationSHA256": "907448ebcf326b135fa7cf0798a7148a8972131c91f928fc18f80a6dd70786ff"
    }
  },
  "/assets/lesson-gcse-biology-understanding-illness-and-wellbeing-81006ea9.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-understanding-illness-and-wellbeing-c0275441.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-understanding-illness-and-wellbeing",
      "lessonRevision": 3,
      "presentationSHA256": "6e8f0919662227736b555eb298411308b125d366e6e40831e4eec7b7df9dd94b"
    }
  },
  "/assets/lesson-gcse-biology-lifestyle-and-chronic-illness-5e84714e.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-lifestyle-and-chronic-illness-c5eaa28d.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-lifestyle-and-chronic-illness",
      "lessonRevision": 3,
      "presentationSHA256": "4139d7acfbea4d865b8b58d375431bbbad3f05f2e6f01e171a81693e094351d6"
    }
  },
  "/assets/lesson-gcse-biology-uncontrolled-growth-of-cells-d87a6d44.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-uncontrolled-growth-of-cells-1eede7df.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-uncontrolled-growth-of-cells",
      "lessonRevision": 3,
      "presentationSHA256": "c8b87fd8e9ec6d5f18684617bc426de7f5b5b0c8dc83bb70e6f73f184a486364"
    }
  },
  "/assets/lesson-gcse-biology-different-tissues-in-plants-229f0b6f.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-different-tissues-in-plants-8d05413c.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-different-tissues-in-plants",
      "lessonRevision": 3,
      "presentationSHA256": "fdde3b182a1d27cca5ee7270e0a15fa1b7c1e5b541faff6ed302c84cfc0c1a67"
    }
  },
  "/assets/lesson-science-plant-transport-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-moving-substances-through-plants-d23addc5.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-moving-substances-through-plants",
      "lessonRevision": 3,
      "presentationSHA256": "1981b9a558b10a92fb0ef4a6d006ff7e12f55b32c8ebdc667db39bef7a70aafc"
    }
  },
  "/assets/lesson-gcse-biology-how-infections-spread-c41fe96e.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-how-infections-spread-3284aa8c.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-how-infections-spread",
      "lessonRevision": 3,
      "presentationSHA256": "3b749ac56932d9759a729e2a0b799c04498f443118d55fb0a388fcf0b8a111e6"
    }
  },
  "/assets/lesson-gcse-biology-illness-caused-by-viruses-9cb782b7.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-illness-caused-by-viruses-f964e084.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-illness-caused-by-viruses",
      "lessonRevision": 4,
      "presentationSHA256": "b3d82f3576948e506849d8a48bf228a49622b4534c3d95541551f97da5f49eb1"
    }
  },
  "/assets/lesson-gcse-biology-illness-caused-by-bacteria-fcf7517b.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-illness-caused-by-bacteria-29c142f4.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-illness-caused-by-bacteria",
      "lessonRevision": 3,
      "presentationSHA256": "2e15a9511bb24084342979571720733b26c1255591c311b71c5af73d7e2edbcd"
    }
  },
  "/assets/lesson-gcse-biology-illness-caused-by-fungi-77311749.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-illness-caused-by-fungi-bff60383.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-illness-caused-by-fungi",
      "lessonRevision": 4,
      "presentationSHA256": "3f12f0f0cd16b9f39f1ab263e84a2ea9a12785aeea2967bab276210e3b7c7837"
    }
  },
  "/assets/lesson-gcse-biology-illness-caused-by-protists-eaa18b41.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-illness-caused-by-protists-edcd3e12.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-illness-caused-by-protists",
      "lessonRevision": 3,
      "presentationSHA256": "9c492c32f5290528c2e53e8457e87a1b70cd3083b9b0d3555ad546b75a6605aa"
    }
  },
  "/assets/lesson-gcse-biology-barriers-and-immune-protection-ce66a48a.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-barriers-and-immune-protection-9b5c089c.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-barriers-and-immune-protection",
      "lessonRevision": 3,
      "presentationSHA256": "a3155c9d9ee226ad124b9f4dcba6f958640134ce166f0e7943d0e011398ab357"
    }
  },
  "/assets/lesson-gcse-biology-preparing-immunity-through-vaccines-7d6de2a7.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-preparing-immunity-through-vaccines-7b36bd3c.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-preparing-immunity-through-vaccines",
      "lessonRevision": 4,
      "presentationSHA256": "00631d67f0c48d9100f5229fbda5bdac13cda7a20137610fa864271ee053404e"
    }
  },
  "/assets/lesson-gcse-biology-treating-infection-and-symptoms-0b17341d.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-treating-infection-and-symptoms-6411f8f1.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-treating-infection-and-symptoms",
      "lessonRevision": 3,
      "presentationSHA256": "7c7742037af4a44fb659c941607e4adf044b3d5e6a03c7f9d46275f3b6334566"
    }
  },
  "/assets/lesson-gcse-biology-testing-medicines-before-use-7c89a069.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-testing-medicines-before-use-4d0a7b90.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-testing-medicines-before-use",
      "lessonRevision": 3,
      "presentationSHA256": "731553ae34cc92af60309ea9ea96118eaaeb0fc10e81ee644e5becc2e86e4e76"
    }
  },
  "/assets/lesson-gcse-biology-biology-of-physical-exertion-e64f813d.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-biology-of-physical-exertion-ed7b70a7.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-biology-of-physical-exertion",
      "lessonRevision": 3,
      "presentationSHA256": "e6c0194b8dc20a6c5e2a42efc4203fe8ea51fc7fdc2a6f198580399bfedb2e93"
    }
  },
  "/assets/lesson-gcse-biology-linked-chemical-reactions-in-organisms-7253a0c4.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-linked-chemical-reactions-in-organisms-38a6a3ad.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-linked-chemical-reactions-in-organisms",
      "lessonRevision": 3,
      "presentationSHA256": "fcdf8312d4072fe723d5f71e90f522e46472337af17a06252f77998b38369f6b"
    }
  },
  "/assets/lesson-gcse-biology-keeping-internal-conditions-steady-cabbeb9d.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-keeping-internal-conditions-steady-4566c32d.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-keeping-internal-conditions-steady",
      "lessonRevision": 3,
      "presentationSHA256": "22816eefe3c749af766147a8a352c56c1f53b33bfff0c908797ae16571311503"
    }
  },
  "/assets/lesson-gcse-biology-communication-through-nerves-9dd8b8e3.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-communication-through-nerves-947907ec.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-communication-through-nerves",
      "lessonRevision": 4,
      "presentationSHA256": "6dd910645f748125545ad0f5a385c2da0e778718aa67920329e42a082b4fc085"
    }
  },
  "/assets/lesson-gcse-biology-investigating-the-control-centre-197ed718.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-investigating-the-control-centre-c80bc72a.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-investigating-the-control-centre",
      "lessonRevision": 3,
      "presentationSHA256": "88a20a7d1fa94d8fd920c5dfb4d198d7e688d8bfa854191e972c7d4737dae039"
    }
  },
  "/assets/lesson-gcse-biology-how-vision-works-10efa496.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-how-vision-works-39b7d317.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-how-vision-works",
      "lessonRevision": 3,
      "presentationSHA256": "24f2c7eaa1f906460a118b2db9219ebb320b16e3bec336770f398f7f07833a67"
    }
  },
  "/assets/lesson-gcse-biology-keeping-body-temperature-stable-4065c772.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-keeping-body-temperature-stable-47cffa35.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-keeping-body-temperature-stable",
      "lessonRevision": 3,
      "presentationSHA256": "b2fa5a36113aecd916d76273f6e42bbb6bc5a53d25c1217985149e174ec6a4ae"
    }
  },
  "/assets/lesson-gcse-biology-chemical-signals-in-circulation-4714b08f.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-chemical-signals-in-circulation-8ae04c87.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-chemical-signals-in-circulation",
      "lessonRevision": 3,
      "presentationSHA256": "73db3a709eb5b4ae4858a38b089036516845938f7f9824a2e84a013eadbb292e"
    }
  },
  "/assets/lesson-gcse-biology-regulating-sugar-in-blood-05c7902e.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-regulating-sugar-in-blood-ee935131.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-regulating-sugar-in-blood",
      "lessonRevision": 4,
      "presentationSHA256": "7c79ddbdbede0827f616d2fc169b477c02e740c0048c1af05f2d34b0b2e49168"
    }
  },
  "/assets/lesson-gcse-biology-managing-water-and-nitrogen-waste-bd1cf2bd.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-managing-water-and-nitrogen-waste-2416bd13.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-managing-water-and-nitrogen-waste",
      "lessonRevision": 3,
      "presentationSHA256": "3b0c7dffe7dc2ab6c791c60a23238f09e5b46b269967d1f995e56e4763b648c2"
    }
  },
  "/assets/lesson-gcse-biology-chemical-control-of-reproduction-0debc6cf.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-chemical-control-of-reproduction-9457b249.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-chemical-control-of-reproduction",
      "lessonRevision": 3,
      "presentationSHA256": "5c5cdb3e6cc8095ea427561a6a7d8d1658b3e555574e9a3344957f39c7013d19"
    }
  },
  "/assets/lesson-gcse-biology-preventing-pregnancy-through-different-approaches-8fa37ce1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-preventing-pregnancy-through-different-approaches-9d8dfa6a.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-preventing-pregnancy-through-different-approaches",
      "lessonRevision": 4,
      "presentationSHA256": "41ad417551ddc539c1005b746463b1cc00e9f22caf1570cff0d9deaf3bf2d3be"
    }
  },
  "/assets/lesson-gcse-biology-hormonal-support-for-fertility-05f03b1d.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-hormonal-support-for-fertility-b6a45bcc.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-hormonal-support-for-fertility",
      "lessonRevision": 3,
      "presentationSHA256": "5400088757f7c7d99f1bd45bd366f15b5655f907d83dc3ae47fbea91a20a61e5"
    }
  },
  "/assets/lesson-gcse-biology-control-through-negative-feedback-3453f186.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-control-through-negative-feedback-0fa87a73.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-control-through-negative-feedback",
      "lessonRevision": 3,
      "presentationSHA256": "4832fde22b76dd7fc84ff7a31d6e0c47ace8e627dbef4800ab2f3ca7b0f054dd"
    }
  },
  "/assets/lesson-gcse-biology-chemical-coordination-in-plants-68789c3e.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-chemical-coordination-in-plants-a91aadcf.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-chemical-coordination-in-plants",
      "lessonRevision": 3,
      "presentationSHA256": "28c1e6afce4f67bf3a5d4ef86db4988611a0670662bf846dc8d6c28f3d8605d4"
    }
  },
  "/assets/lesson-gcse-biology-applying-plant-growth-signals-539d876a.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-applying-plant-growth-signals-cc2eae6a.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-applying-plant-growth-signals",
      "lessonRevision": 4,
      "presentationSHA256": "0a3f4bd4219b6dc3db6fca4b3502273fa218c042603ea09b4fbc9930ee7a69e1"
    }
  },
  "/assets/lesson-gcse-biology-reproduction-with-and-without-gametes-ac7d7298.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-reproduction-with-and-without-gametes-03353393.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-reproduction-with-and-without-gametes",
      "lessonRevision": 3,
      "presentationSHA256": "d3cc75261ecbd3862e2341996432c6b7a538d6478633ab19f5c0eb23514aa15b"
    }
  },
  "/assets/lesson-gcse-biology-making-genetically-varied-gametes-00bf1a3a.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-making-genetically-varied-gametes-74222fc5.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-making-genetically-varied-gametes",
      "lessonRevision": 3,
      "presentationSHA256": "90f8f495cab0b2b9e24d6b581f9891ec4a987f96bf343cce7461df0cfc726984"
    }
  },
  "/assets/lesson-gcse-biology-comparing-reproductive-strategies-4a661e28.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-comparing-reproductive-strategies-e202bf83.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-comparing-reproductive-strategies",
      "lessonRevision": 3,
      "presentationSHA256": "84728bea79db0ea324758cd0caac06634e3fada2819239940ab73f150caf71f7"
    }
  },
  "/assets/lesson-gcse-biology-reading-the-genetic-library-ea6343b0.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-reading-the-genetic-library-1fcdf708.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-reading-the-genetic-library",
      "lessonRevision": 3,
      "presentationSHA256": "799c187cb6c6d461eabc4e776cace9b1c1b682412a856f23d4ca636710f1204f"
    }
  },
  "/assets/lesson-gcse-biology-how-hereditary-molecules-are-organised-36ac4409.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-how-hereditary-molecules-are-organised-a7eda916.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-how-hereditary-molecules-are-organised",
      "lessonRevision": 4,
      "presentationSHA256": "d80d895d13f42dd2c429a68434a91ad6993e74f9d38b856a641e46e61d4884c4"
    }
  },
  "/assets/lesson-gcse-biology-predicting-inherited-traits-3a395d70.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-predicting-inherited-traits-514a9e8b.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-predicting-inherited-traits",
      "lessonRevision": 3,
      "presentationSHA256": "6c90cd9340d5803ce271784418dbc492ba405196a6e7928da3d5fb68c13e638b"
    }
  },
  "/assets/lesson-gcse-biology-conditions-passed-through-genes-9322b01f.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-conditions-passed-through-genes-e9972fc0.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-conditions-passed-through-genes",
      "lessonRevision": 3,
      "presentationSHA256": "9314d4464c4c16bcc45f1434f52e7154f8752cfa1b4e8ccd2e5f597fba798a11"
    }
  },
  "/assets/lesson-gcse-biology-inheritance-of-biological-sex-7372ec46.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-inheritance-of-biological-sex-8b7cdc16.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-inheritance-of-biological-sex",
      "lessonRevision": 4,
      "presentationSHA256": "5d13b8c8a8bdf4b996e48b98dd12ccb1e6f1a03f82105469eeeb7ea117fcf921"
    }
  },
  "/assets/lesson-gcse-biology-why-individuals-differ-7bc2004b.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-why-individuals-differ-f7ce0d16.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-why-individuals-differ",
      "lessonRevision": 3,
      "presentationSHA256": "fbf58e2180ce6dcd694eafa54421ec6917bcb70e38947fd1e2eca732c29ef47f"
    }
  },
  "/assets/lesson-gcse-biology-changing-populations-across-generations-9d945f5f.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-changing-populations-across-generations-db92da3f.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-changing-populations-across-generations",
      "lessonRevision": 3,
      "presentationSHA256": "be291212b3824ed2af135b306e51d6c85b49c5fd4f04c892b4d3d015022293c8"
    }
  },
  "/assets/lesson-gcse-biology-breeding-for-chosen-traits-096cfabb.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-breeding-for-chosen-traits-eb5d00ab.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-breeding-for-chosen-traits",
      "lessonRevision": 4,
      "presentationSHA256": "265cc0215070fb3de3e695cb964d12e3f5809f07c69c5811b6ecf2ae9148cfa2"
    }
  },
  "/assets/lesson-gcse-biology-changing-genes-deliberately-c0dcd562.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-changing-genes-deliberately-9049af2e.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-changing-genes-deliberately",
      "lessonRevision": 4,
      "presentationSHA256": "0205c657ae32f47fc7b4ae4d329175ad3ef9c53460598cc56ab31908dbac60fd"
    }
  },
  "/assets/lesson-gcse-biology-producing-genetically-matching-organisms-e3464c35.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-producing-genetically-matching-organisms-f618ef16.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-producing-genetically-matching-organisms",
      "lessonRevision": 3,
      "presentationSHA256": "7931bdcc63acb4e540f9e655fd8ec225316a2065d418013098f9b6295d25950c"
    }
  },
  "/assets/lesson-gcse-biology-how-evolutionary-explanations-developed-356dc192.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-how-evolutionary-explanations-developed-50ac0904.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-how-evolutionary-explanations-developed",
      "lessonRevision": 4,
      "presentationSHA256": "bce4793f589db6eb0033f2ffe120da0dbf5b250a896e2fdc78f8de84446e2f7b"
    }
  },
  "/assets/lesson-gcse-biology-how-new-species-arise-ef5b72bf.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-how-new-species-arise-47208d0c.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-how-new-species-arise",
      "lessonRevision": 4,
      "presentationSHA256": "e48ab0e6e70cc76d43141f6a24be9898b317ffe400661c352c8ed8ad61f910f1"
    }
  },
  "/assets/lesson-gcse-biology-building-explanations-of-inheritance-d61e7593.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-building-explanations-of-inheritance-ffa67560.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-building-explanations-of-inheritance",
      "lessonRevision": 4,
      "presentationSHA256": "7d9d40cb07b291880655a2a8e984ada3991d981a22707e1e0b2dcd06d15f23c0"
    }
  },
  "/assets/lesson-gcse-biology-testing-evolutionary-explanations-c2c9bce8.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-testing-evolutionary-explanations-9e82e817.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-testing-evolutionary-explanations",
      "lessonRevision": 4,
      "presentationSHA256": "928a85fe84cf1fcb1240098bb22d60e7303175b97ec266a44719da2baff0eac3"
    }
  },
  "/assets/lesson-gcse-biology-traces-of-past-organisms-721cf1d9.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-traces-of-past-organisms-a062668c.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-traces-of-past-organisms",
      "lessonRevision": 4,
      "presentationSHA256": "5f70fa58bfb036708473dd73f9ebf665a64393f7f77d04b8ef95df7caf6a8ec2"
    }
  },
  "/assets/lesson-gcse-biology-when-species-disappear-762420df.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-when-species-disappear-a011ac97.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-when-species-disappear",
      "lessonRevision": 3,
      "presentationSHA256": "eceae952339b65f011472f9815904dbbc94bc929fe355094377762efc7f691f6"
    }
  },
  "/assets/lesson-gcse-biology-bacteria-surviving-antibiotic-exposure-3ac8f33e.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-bacteria-surviving-antibiotic-exposure-8e146984.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-bacteria-surviving-antibiotic-exposure",
      "lessonRevision": 3,
      "presentationSHA256": "0fa4961163cae3dbcaf5ac33e9a5ef690dfd931ab6916039bc93bd3ea7bcd7e3"
    }
  },
  "/assets/lesson-gcse-biology-organising-life-s-diversity-5fbec159.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-organising-life-s-diversity-509c9892.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-organising-life-s-diversity",
      "lessonRevision": 3,
      "presentationSHA256": "814e5e21ef3fa4af7451bf4ac21ffb3f96b85574cfab582629c9f216c521e212"
    }
  },
  "/assets/lesson-gcse-biology-networks-of-living-populations-e0f36205.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-networks-of-living-populations-2708ab88.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-networks-of-living-populations",
      "lessonRevision": 3,
      "presentationSHA256": "a7c0384c0790fe300c6f061abf8cbeb697c64da18e464a061509b6780ab420ae"
    }
  },
  "/assets/lesson-gcse-biology-nonliving-influences-on-ecosystems-329c0bd7.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-nonliving-influences-on-ecosystems-6bb2eaa4.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-nonliving-influences-on-ecosystems",
      "lessonRevision": 3,
      "presentationSHA256": "88350fc2e11fef43683370c7df1adc1b187d26c2c527f150d5e819a28c7c0f8e"
    }
  },
  "/assets/lesson-gcse-biology-living-influences-on-ecosystems-d7315fba.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-living-influences-on-ecosystems-9bc09d1e.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-living-influences-on-ecosystems",
      "lessonRevision": 3,
      "presentationSHA256": "21532a07f6333a28fc533529fd353731df94d6c5e7bc7e057d1cc49ef3cd7629"
    }
  },
  "/assets/lesson-gcse-biology-features-aiding-survival-cf9bbcf6.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-features-aiding-survival-19652498.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-features-aiding-survival",
      "lessonRevision": 3,
      "presentationSHA256": "bf7fbb84e6323e0f42d366a527a4d2489232c59cba08b410662855ee34bd9caa"
    }
  },
  "/assets/lesson-gcse-biology-linking-organisms-across-ecosystems-7f314619.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-linking-organisms-across-ecosystems-c47f8444.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-linking-organisms-across-ecosystems",
      "lessonRevision": 3,
      "presentationSHA256": "75bd7fc83ddfbbbdf0213fe8f4880e4ff232ae418e2a19ef7bdc182cb19842df"
    }
  },
  "/assets/lesson-gcse-biology-breaking-down-organic-remains-29b3fb5d.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-breaking-down-organic-remains-f98c550c.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-breaking-down-organic-remains",
      "lessonRevision": 3,
      "presentationSHA256": "a63a7f7cde0d6745334bf59b5c6a50b0395fbbff2303b5575e4e6c81ea87c87d"
    }
  },
  "/assets/lesson-gcse-biology-ecosystems-under-changing-conditions-1fca2e98.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-ecosystems-under-changing-conditions-69cd3180.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-ecosystems-under-changing-conditions",
      "lessonRevision": 3,
      "presentationSHA256": "6adc3f0737a0fe5f0ef81d45933978efad82fcf105ae9403916edbf6be6cbf65"
    }
  },
  "/assets/lesson-gcse-biology-variety-of-living-organisms-781cd4c3.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-variety-of-living-organisms-798b077b.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-variety-of-living-organisms",
      "lessonRevision": 3,
      "presentationSHA256": "f53b2d8bce967e31591f38329c35aac6422458424314595c1ffcfd10edaad57a"
    }
  },
  "/assets/lesson-gcse-biology-handling-human-waste-ed88a0a4.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-handling-human-waste-26187e70.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-handling-human-waste",
      "lessonRevision": 3,
      "presentationSHA256": "7dd0682d67a2cc6d05a8831e481edfa9079f984722524ab717d59994509e9853"
    }
  },
  "/assets/lesson-gcse-biology-human-choices-about-landscapes-849a516b.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-human-choices-about-landscapes-2d38d29e.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-human-choices-about-landscapes",
      "lessonRevision": 3,
      "presentationSHA256": "dc2b44361121b5ef241721efd180ce1d3413bd78c8c3ade7310e4a2bc842e874"
    }
  },
  "/assets/lesson-gcse-biology-consequences-of-forest-removal-b9cd8a9b.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-consequences-of-forest-removal-c6b28eba.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-consequences-of-forest-removal",
      "lessonRevision": 3,
      "presentationSHA256": "ef00df806c12924c1e491b0fa33c045c44072d7eaf26a6000a27a992ee1c342c"
    }
  },
  "/assets/lesson-gcse-biology-rising-global-temperatures-1958add7.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-rising-global-temperatures-0e6eb6f4.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-rising-global-temperatures",
      "lessonRevision": 3,
      "presentationSHA256": "183fdc9d890935a9519adfbbbdc1450642855dae7fc5534d3e000d00cf2446b5"
    }
  },
  "/assets/lesson-gcse-biology-protecting-life-s-variety-40f94602.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-protecting-life-s-variety-b9a40960.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-protecting-life-s-variety",
      "lessonRevision": 3,
      "presentationSHA256": "38eae3a165d46a9be561c53fe56d2e82ab2fda69a4972bdb03c8b89608f0f432"
    }
  },
  "/assets/lesson-gcse-biology-feeding-positions-in-ecosystems-2cb9f82a.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-feeding-positions-in-ecosystems-02b26cfe.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-feeding-positions-in-ecosystems",
      "lessonRevision": 3,
      "presentationSHA256": "1c10bf6392adafefb2e83fac89a774b635a66b89813356ab8fd33f82ce2bfaa1"
    }
  },
  "/assets/lesson-gcse-biology-comparing-biomass-across-feeding-positions-412fa90e.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-comparing-biomass-across-feeding-positions-ed24786f.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-comparing-biomass-across-feeding-positions",
      "lessonRevision": 3,
      "presentationSHA256": "09a0dfa0e418c9155dd1aa57678611486b1a5aa68ad346f15230d52d1101c926"
    }
  },
  "/assets/lesson-gcse-biology-following-biomass-between-organisms-838eca67.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-following-biomass-between-organisms-dc762cb0.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-following-biomass-between-organisms",
      "lessonRevision": 3,
      "presentationSHA256": "db6378a76f158d5690d2ddf026627a050b26dc8789eecde4b638f7b770035552"
    }
  },
  "/assets/lesson-gcse-biology-reliable-access-to-food-c3fe1ac2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-reliable-access-to-food-085fa392.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-reliable-access-to-food",
      "lessonRevision": 4,
      "presentationSHA256": "cea30d0856d478e7e485aed44e968a168bdd5879595835fcdb5e4fe268433981"
    }
  },
  "/assets/lesson-gcse-biology-methods-of-agricultural-production-8046d5bf.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-methods-of-agricultural-production-f8ea429b.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-methods-of-agricultural-production",
      "lessonRevision": 3,
      "presentationSHA256": "5e0b176f2cdec946b782ac80a1e1aaf324e52b42f89da8687c5473efedc338a6"
    }
  },
  "/assets/lesson-gcse-biology-managing-catches-for-the-future-0dcc5f5d.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-managing-catches-for-the-future-0034cfc9.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-managing-catches-for-the-future",
      "lessonRevision": 3,
      "presentationSHA256": "376e0c62f6ee7083f8225237fe8c4c332e4f5e1de2cf72467640790350f3e197"
    }
  },
  "/assets/lesson-gcse-biology-using-organisms-in-food-production-980a030f.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-using-organisms-in-food-production-08d33125.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-using-organisms-in-food-production",
      "lessonRevision": 4,
      "presentationSHA256": "9ea660fa80256a4e6e0694b32bbe6f1e1544b5822f66a62f5a1b076ecc2e24c1"
    }
  },
  "/assets/lesson-gcse-biology-connecting-core-biological-principles-02bc3721.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-connecting-core-biological-principles-e6ede220.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-connecting-core-biological-principles",
      "lessonRevision": 3,
      "presentationSHA256": "c39eac26cd70f3c30d14e3de5ebaca292243e10757673f4c923dcd7f07e0170e"
    }
  },
  "/assets/lesson-science-gcse-biology-rp-1-8-j.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-reading-and-scaling-microscope-observations-5206be85.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-reading-and-scaling-microscope-observations",
      "lessonRevision": 3,
      "presentationSHA256": "36def3b152e279f8cc5b0da765786afe5bc5e5e1377a1885322d08dcfa80a576"
    }
  },
  "/assets/lesson-science-gcse-biology-rp-2-8-j.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-interpreting-bacterial-inhibition-zones-32660754.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-interpreting-bacterial-inhibition-zones",
      "lessonRevision": 3,
      "presentationSHA256": "080c39ca2e2b5cbda3d8592acb3e14dcefe7ef4f11c71c22aac0d214fd2bdf97"
    }
  },
  "/assets/lesson-science-gcse-biology-rp-3-8-j.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-analysing-tissue-mass-changes-by-osmosis-2c3d4c76.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-analysing-tissue-mass-changes-by-osmosis",
      "lessonRevision": 3,
      "presentationSHA256": "cca24e0a15a22b213208255e4b74a770d1e44ca569b8081c25bf0b48e8ec7db6"
    }
  },
  "/assets/lesson-science-gcse-biology-rp-4-8-j.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-using-controls-to-interpret-food-tests-279fe73c.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-using-controls-to-interpret-food-tests",
      "lessonRevision": 3,
      "presentationSHA256": "9fd8636ccab510572cd1eac797d108a54c904ebf9b1ddfbdb9bda2d6aa3f3745"
    }
  },
  "/assets/lesson-science-gcse-biology-rp-5-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-comparing-amylase-activity-across-ph-61f6a099.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-comparing-amylase-activity-across-ph",
      "lessonRevision": 3,
      "presentationSHA256": "d30536180e50282f0dd716ccdb39ba2446c6da27e5f66a6cd1d579138a44a082"
    }
  },
  "/assets/lesson-science-gcse-biology-rp-6-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-measuring-photosynthetic-rate-under-changing-light-27e6e1ef.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-measuring-photosynthetic-rate-under-changing-light",
      "lessonRevision": 3,
      "presentationSHA256": "6a80ab1d3b8a4023b3d5656bd8016459f9b09500f68fbb53c287d659d3ac1451"
    }
  },
  "/assets/lesson-science-gcse-biology-rp-7-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-evaluating-a-human-reaction-time-comparison-6d96863e.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-evaluating-a-human-reaction-time-comparison",
      "lessonRevision": 3,
      "presentationSHA256": "ef0c95a49fd74d5a3ca57d033bdcf7f920f6f49d8d6255b442d8a787e3fc14b2"
    }
  },
  "/assets/lesson-science-gcse-biology-rp-8-v3.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-following-seedling-growth-responses-over-time-a0db80f2.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-following-seedling-growth-responses-over-time",
      "lessonRevision": 3,
      "presentationSHA256": "58ceb5aee30850fe5aeb6b59d6153a3ac918b0472ddea0dc9ea70dbe20747b55"
    }
  },
  "/assets/lesson-science-gcse-biology-rp-9-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-estimating-abundance-and-testing-a-habitat-gradient-19f5b657.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-estimating-abundance-and-testing-a-habitat-gradient",
      "lessonRevision": 3,
      "presentationSHA256": "7d379b33fabd7811b24cd3cfca59353e7c25d9db45d0aabe34e2d32782b6c816"
    }
  },
  "/assets/lesson-science-gcse-biology-rp-10-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280],
    "replaces": {
      "url": "/assets/retired-gcse-biology-interpreting-temperature-effects-on-milk-decay-abb3b354.svg",
      "courseId": "uk-gcse-biology",
      "lessonId": "uk-gcse-biology-interpreting-temperature-effects-on-milk-decay",
      "lessonRevision": 3,
      "presentationSHA256": "eefbf795f630d6872fa752305253046a7298d57e8078d11fd95e7dfc379855bb"
    }
  },
  "/assets/history-leader-alexander-iii-v1.webp": {
    "width": 1122,
    "height": 1402,
    "widths": [160, 640, 1122]
  },
  "/assets/history-leader-mansa-musa-v1.webp": {
    "width": 1122,
    "height": 1402,
    "widths": [160, 640, 1122]
  },
  "/assets/history-leader-sejong-v1.webp": {
    "width": 1122,
    "height": 1402,
    "widths": [160, 640, 1122]
  },
  "/assets/history-leader-hammurabi-v1.webp": {
    "width": 1122,
    "height": 1402,
    "widths": [160, 640, 1122]
  },
  "/assets/history-leader-amanitore-v1.webp": {
    "width": 1122,
    "height": 1402,
    "widths": [160, 640, 1122]
  },
  "/assets/history-leader-lautaro-v1.webp": {
    "width": 1122,
    "height": 1402,
    "widths": [160, 640, 1122]
  },
  "/assets/history-leader-tokugawa-ieyasu-v1.webp": {
    "width": 1122,
    "height": 1402,
    "widths": [160, 640, 1122]
  },
  "/assets/history-leader-harald-hardrada-v1.webp": {
    "width": 1122,
    "height": 1402,
    "widths": [160, 640, 1122]
  },
  "/assets/history-leader-jayavarman-vii-v1.webp": {
    "width": 1122,
    "height": 1402,
    "widths": [160, 640, 1122]
  },
  "/assets/history-leader-trajan-v1.webp": {
    "width": 1122,
    "height": 1402,
    "widths": [160, 640, 1122]
  },
  "/assets/history-leader-ramesses-ii-v1.webp": {
    "width": 1122,
    "height": 1402,
    "widths": [160, 640, 1122]
  },
  "/assets/history-leader-theodora-v1.webp": {
    "width": 1122,
    "height": 1402,
    "widths": [160, 640, 1122]
  },
  "/assets/intro-maths-rendered-1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/intro-physics-rendered-1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/intro-chemistry-rendered-1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/intro-biology-rendered-1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/history-leader-concept-qin-shi-huang.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/history-leader-concept-suleiman-i.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/history-leader-concept-kublai-khan.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/history-leader-concept-eleanor-of-aquitaine.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/history-leader-concept-mvemba-a-nzinga.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/history-leader-concept-robert-the-bruce.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-chemistry-atomic-atomic.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-chemistry-atomic-isotopes.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-chemistry-atomic-groups.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-chemistry-atomic-mixtures.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-chemistry-atomic-transition.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-chemistry-bonding-ionic.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-chemistry-bonding-states.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-chemistry-bonding-covalent.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-chemistry-bonding-metal.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-chemistry-bonding-carbon.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-chemistry-bonding-nano.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-chemistry-bonding-diamond.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-chemistry-bonding-polymer.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-positions-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-operations-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-primes-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-powers-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-exact-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-fractions-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-scale-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-accuracy-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-recurring-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-root-estimates-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-calculated-bounds-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-algebra-notation-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-algebra-area-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-algebra-formula-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-algebra-higher-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-algebra-functions-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-physics-energy-stores.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-physics-energy-mechanical.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-physics-energy-thermal.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-physics-energy-power.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-physics-energy-insulation.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-physics-energy-efficiency.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-physics-energy-resources.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-graphs-line-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-graphs-quadratic-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-graphs-families-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-graphs-transform-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-graphs-motion-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-graphs-circle-v3.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-equations-linear-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-equations-quadratic-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-equations-simultaneous-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-equations-inequalities-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-sequences-patterns-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-equations-iteration-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-equations-regions-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-sequences-families-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-ratio-parts-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-ratio-map-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-ratio-percent-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-ratio-proportion-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-ratio-measures-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-ratio-similarity-v3.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-ratio-growth-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-ratio-rates-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-gcse-french-discuss-a-public-figure-using-facts-and-a-stated-opinion-e5d4e9b9.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-gcse-french-describe-an-everyday-routine-without-turning-it-into-health-advice-85757a71.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-gcse-french-compare-two-leisure-choices-and-their-reasons-f62cbd84.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-generator-v1.webp": {
    "width": 1280,
    "height": 854,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-transformer-v2.webp": {
    "width": 1280,
    "height": 854,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-pump-v1.webp": {
    "width": 1280,
    "height": 854,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-heatpump-v2.webp": {
    "width": 1280,
    "height": 854,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-aluminium-v2.webp": {
    "width": 1280,
    "height": 854,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-titanium-v1.webp": {
    "width": 1280,
    "height": 854,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-geography-hazards-risk.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-geography-hazards-boundaries.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-geography-hazards-cascade.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-geography-hazards-preparedness.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-geography-hazards-circulation.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-geography-hazards-cyclone.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-geography-hazards-climate-response.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-geography-hazards-climate-evidence.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-geography-ecosystems-pond-food-web.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-geography-ecosystems-rainforest-cycle.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-geography-ecosystems-forest-fragmentation.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-cmos-v2.webp": {
    "width": 1280,
    "height": 854,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-chip-design-v2.webp": {
    "width": 1280,
    "height": 854,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-wafer-pattern-v1.webp": {
    "width": 1280,
    "height": 854,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-package-yield-v1.webp": {
    "width": 1280,
    "height": 854,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-ai-memory-v1.webp": {
    "width": 1280,
    "height": 854,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-training-inference-v1.webp": {
    "width": 1280,
    "height": 854,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-distributed-v2.webp": {
    "width": 1280,
    "height": 854,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-datacentre-v2.webp": {
    "width": 1280,
    "height": 854,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-chemistry-quantitative-mass-v2.webp": {
    "width": 1280,
    "height": 854,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-chemistry-quantitative-formula-v1.webp": {
    "width": 1280,
    "height": 854,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-chemistry-quantitative-measurement-v1.webp": {
    "width": 1280,
    "height": 854,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-chemistry-amount-model-v3.webp": {
    "width": 1280,
    "height": 854,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-chemistry-quantitative-ratio-v1.webp": {
    "width": 1280,
    "height": 854,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-chemistry-quantitative-concentration-v1.webp": {
    "width": 1280,
    "height": 854,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-chemistry-quantitative-efficiency-v1.webp": {
    "width": 1280,
    "height": 854,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-chemistry-quantitative-dilution-v1.webp": {
    "width": 1280,
    "height": 854,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-chemistry-gas-volume-v2.webp": {
    "width": 1280,
    "height": 854,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-geography-urban-networks.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-geography-urban-access.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-geography-resource-system.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-geography-human-development.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-geography-mapping-skills.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-geography-evidence-enquiry.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-a-level-chemistry-independent-atomic-1-v1.webp": {
    "width": 1280,
    "height": 640,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-a-level-chemistry-independent-atomic-2-v1.webp": {
    "width": 1280,
    "height": 854,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-a-level-chemistry-independent-atomic-3-v1.webp": {
    "width": 1280,
    "height": 854,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-a-level-chemistry-independent-atomic-4-v1.webp": {
    "width": 1280,
    "height": 854,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-hydroelectric-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-pumped-storage-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-transmission-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-insulation-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-how-023-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-how-025-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-how-029-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-solar-pv-v1.webp": {
    "width": 1280,
    "height": 854,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-wind-v1.webp": {
    "width": 1280,
    "height": 854,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-lithium-v3.webp": {
    "width": 1280,
    "height": 854,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-motor-v2.webp": {
    "width": 1280,
    "height": 854,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-gears-v1.webp": {
    "width": 1280,
    "height": 854,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-engine-v2.webp": {
    "width": 1280,
    "height": 854,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-steel-v2.webp": {
    "width": 1280,
    "height": 854,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-glass-v2.webp": {
    "width": 1280,
    "height": 854,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-next-hydraulic-v4.webp": {
    "width": 1280,
    "height": 854,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-next-thermal-v2.webp": {
    "width": 1280,
    "height": 854,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-next-water-v1.webp": {
    "width": 1280,
    "height": 512,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-next-fiber-v1.webp": {
    "width": 1280,
    "height": 534,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-next-radio-v2.webp": {
    "width": 1280,
    "height": 534,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-next-gnss-v1.webp": {
    "width": 1280,
    "height": 854,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-next-bridge-v2.webp": {
    "width": 1280,
    "height": 640,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-next-control-v1.webp": {
    "width": 1280,
    "height": 854,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-lead-acid-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-hydrogen-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-led-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-microwave-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-how-035-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-how-055-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-fission-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-geothermal-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-washer-v3.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-vacuum-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-combined-cycle-v4.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-solar-thermal-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-how-054-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-how-059-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-how-056-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-how-058-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-biogas-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-compression-ignition-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-how-061-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-how-062-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-how-064-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-how-065-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-how-066-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-how-067-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-how-068-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-how-069-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-ups-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-microgrid-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-protection-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-inverter-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-how-070-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-how-073-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-physics-electricity-review-01.webp": {
    "width": 1280,
    "height": 854,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-physics-electricity-review-02.webp": {
    "width": 1280,
    "height": 854,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-physics-electricity-review-03.webp": {
    "width": 1280,
    "height": 854,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-physics-electricity-review-04.webp": {
    "width": 1280,
    "height": 534,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-physics-electricity-review-05.webp": {
    "width": 1280,
    "height": 854,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-physics-electricity-review-06.webp": {
    "width": 1280,
    "height": 854,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-physics-particle-density-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-physics-particle-state-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-humidity-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-filtration-v3.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-wifi-v4.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-camera-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-physics-electricity-ac-dc-depth.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-physics-electricity-mains-safety-depth.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-physics-electricity-electrical-transfers-depth.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-physics-electricity-grid-depth.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-physics-electricity-static-depth.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-physics-electricity-fields-depth.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-physics-electricity-transfer-audit-depth.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-wastewater-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-distribution-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-irrigation-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-reinforcement-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-chemistry-change-reactivity.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-chemistry-change-salt.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-chemistry-change-titration.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-chemistry-change-transport.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-chemistry-aqueous-model-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-chemistry-change-aluminium.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-chemistry-change-acid-redox.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-geometry-shapes-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-geometry-angles-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-geometry-construction-v3.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-geometry-parallel-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-geometry-congruence-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-steam-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-jet-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-wing-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-lift-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-ultrasound-v3.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-pulseox-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-physics-units.webp": { "width": 1280, "height": 640, "widths": [160, 640, 1280] },
  "/assets/lesson-physics-measurement.webp": {
    "width": 1280,
    "height": 533,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-physics-graphs.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-physics-estimation.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-physics-atom.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/lesson-physics-beta.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/lesson-physics-annihilation.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-physics-interactions.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-physics-quarks.webp": {
    "width": 1280,
    "height": 640,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-physics-photon.webp": {
    "width": 1280,
    "height": 640,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-physics-duality.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-ct-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-mri-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-ecg-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-dialysis-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-chemistry-advanced-mole-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-chemistry-advanced-solutions-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-chemistry-advanced-gases-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-chemistry-advanced-formula-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-chemistry-advanced-stoichiometry-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-chemistry-advanced-ionic-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-chemistry-advanced-covalent-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-chemistry-advanced-shapes-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-chemistry-energy-transfer.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-chemistry-temperature-change-comparison-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-chemistry-energy-profiles.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-chemistry-energy-bonds.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-chemistry-energy-cells.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-chemistry-energy-batteries.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-chemistry-energy-fuel.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-chemistry-energy-half-equations.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-prosthetics-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-sterilisation-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-cold-chain-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-pasteurisation-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-elit-evidence.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/lesson-elit-agency.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/lesson-elit-welcome-v3.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-elit-motifs.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/lesson-elit-countervoices-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-elit-unseen-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-railways-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-ship-propulsion-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-chemistry-advanced-metallic-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-chemistry-advanced-structures-v3.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-chemistry-advanced-polarity-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-chemistry-advanced-forces-v3.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-bicycle-gearing-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-traffic-queues-v3.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-harvesting-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-precision-agriculture-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-geography-depth-warning-budget-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-geography-depth-nepal-access-network-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-geography-depth-tohoku-cascade-model-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-geography-depth-forecast-cone-reading-v3.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-geography-depth-surge-tide-datum-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-geography-depth-uk-heat-verification-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-geography-depth-annual-risk-reasoning-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-geography-depth-adaptation-distribution-appraisal-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-flood-storage-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-air-monitoring-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-maths-9ma0-reflection-v2.webp": {
    "width": 1280,
    "height": 1254,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-maths-9ma0-inverse-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-maths-9ma0-proof-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-maths-9ma0-exact-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-maths-9ma0-quadratics-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-maths-9ma0-substitution-v1.webp": {
    "width": 1280,
    "height": 1286,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-maths-9ma0-simultaneous-v3.webp": {
    "width": 1280,
    "height": 1374,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-maths-9ma0-signs-v1.webp": {
    "width": 1280,
    "height": 640,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-maths-9ma0-division-v1.webp": {
    "width": 1280,
    "height": 1067,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-maths-9ma0-graphs-v1.webp": {
    "width": 1280,
    "height": 427,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-maths-9ma0-transform-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-maths-9ma0-modulus-v2.webp": {
    "width": 1280,
    "height": 1067,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-maths-9ma0-model-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-maths-9ma0-sector-v2.webp": {
    "width": 1280,
    "height": 1287,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-maths-9ma0-secant-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-maths-9ma0-trig-equation-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-seismic-isolation-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-district-heating-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-graphene-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-generator-loaded-depth-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-generator-maintenance-depth-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-solar-output-depth-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-solar-lifecycle-depth-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-cs-binary.webp": { "width": 1536, "height": 1024, "widths": [160, 640, 1536] },
  "/assets/lesson-cs-boolean.webp": { "width": 1536, "height": 1024, "widths": [160, 640, 1536] },
  "/assets/lesson-cs-direct-alias.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-cs-direct-bubble.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-cs-direct-gates.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-cs-direct-huffman.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-cs-direct-linear.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-cs-loop.webp": { "width": 1536, "height": 1024, "widths": [160, 640, 1536] },
  "/assets/lesson-cs-media.webp": { "width": 1536, "height": 1024, "widths": [160, 640, 1536] },
  "/assets/lesson-cs-merge.webp": { "width": 1536, "height": 1024, "widths": [160, 640, 1536] },
  "/assets/lesson-cs-search.webp": { "width": 1536, "height": 1024, "widths": [160, 640, 1536] },
  "/assets/lesson-engineering-wind-variable-depth-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-wind-fatigue-depth-v3.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-economics-plate-01.webp": {
    "width": 1536,
    "height": 1024,
    "widths": [160, 640, 1536]
  },
  "/assets/lesson-economics-plate-02.webp": {
    "width": 1774,
    "height": 887,
    "widths": [160, 640, 1774]
  },
  "/assets/lesson-economics-plate-03.webp": {
    "width": 1536,
    "height": 1024,
    "widths": [160, 640, 1536]
  },
  "/assets/lesson-economics-plate-04.webp": {
    "width": 1536,
    "height": 1024,
    "widths": [160, 640, 1536]
  },
  "/assets/lesson-economics-plate-05.webp": {
    "width": 1536,
    "height": 1024,
    "widths": [160, 640, 1536]
  },
  "/assets/lesson-economics-plate-06.webp": {
    "width": 1774,
    "height": 887,
    "widths": [160, 640, 1774]
  },
  "/assets/lesson-economics-plate-07.webp": {
    "width": 1536,
    "height": 1024,
    "widths": [160, 640, 1536]
  },
  "/assets/lesson-economics-plate-08.webp": {
    "width": 1536,
    "height": 1024,
    "widths": [160, 640, 1536]
  },
  "/assets/lesson-engineering-hydro-head-depth-v5.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-hydro-river-depth-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-sociology-reasoning-v1.webp": {
    "width": 1536,
    "height": 1024,
    "widths": [160, 640, 1536]
  },
  "/assets/lesson-sociology-measurement-v1.webp": {
    "width": 1536,
    "height": 1024,
    "widths": [160, 640, 1536]
  },
  "/assets/lesson-sociology-sampling-v1.webp": {
    "width": 1536,
    "height": 1024,
    "widths": [160, 640, 1536]
  },
  "/assets/lesson-sociology-ethics-v1.webp": {
    "width": 1536,
    "height": 1024,
    "widths": [160, 640, 1536]
  },
  "/assets/lesson-sociology-families-v1.webp": {
    "width": 1774,
    "height": 887,
    "widths": [160, 640, 1774]
  },
  "/assets/lesson-sociology-education-v2.webp": {
    "width": 1536,
    "height": 1024,
    "widths": [160, 640, 1536]
  },
  "/assets/lesson-sociology-crime-17-v1.webp": {
    "width": 1536,
    "height": 1024,
    "widths": [160, 640, 1536]
  },
  "/assets/lesson-sociology-crime-18-v1.webp": {
    "width": 1536,
    "height": 1024,
    "widths": [160, 640, 1536]
  },
  "/assets/lesson-sociology-crime-19-v1.webp": {
    "width": 1536,
    "height": 1024,
    "widths": [160, 640, 1536]
  },
  "/assets/lesson-sociology-crime-20-v1.webp": {
    "width": 1536,
    "height": 1024,
    "widths": [160, 640, 1536]
  },
  "/assets/lesson-cs-hardware-software-systems.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-cs-cpu-roles-systems.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-cs-fetch-decode-execute-systems.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-cs-memory-hierarchy-systems.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-cs-cpu-performance-systems.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-cs-secondary-storage-systems.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-cs-embedded-general-systems.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-cs-os-resources-systems.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-computing-advanced-contracts-v1.webp": {
    "width": 1280,
    "height": 640,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-computing-advanced-predicates-v2.webp": {
    "width": 1280,
    "height": 854,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-computing-advanced-loop-v1.webp": {
    "width": 1280,
    "height": 854,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-computing-advanced-alias-v2.webp": {
    "width": 1280,
    "height": 854,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-computing-advanced-recursion-v2.webp": {
    "width": 1280,
    "height": 854,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-computing-advanced-records-v1.webp": {
    "width": 1280,
    "height": 640,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-computing-advanced-objects-v1.webp": {
    "width": 1280,
    "height": 640,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-computing-advanced-circular-queue-v1.webp": {
    "width": 1280,
    "height": 640,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-computing-advanced-search-v1.webp": {
    "width": 1280,
    "height": 854,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-computing-advanced-sorting-v1.webp": {
    "width": 1280,
    "height": 854,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-computing-advanced-graph-v1.webp": {
    "width": 1280,
    "height": 854,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-computing-advanced-complexity-v1.webp": {
    "width": 1280,
    "height": 640,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-computing-advanced-parity-fsm-v1.webp": {
    "width": 1280,
    "height": 640,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-computing-advanced-grammar-v1.webp": {
    "width": 1280,
    "height": 854,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-computing-advanced-turing-v1.webp": {
    "width": 1280,
    "height": 854,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-computing-advanced-functional-v1.webp": {
    "width": 1280,
    "height": 854,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-computing-advanced-number-domains-bases-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-computing-advanced-information-capacity-units-v1.webp": {
    "width": 1280,
    "height": 640,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-computing-advanced-unsigned-arithmetic-overflow-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-computing-advanced-signed-subtraction-boundaries-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-computing-advanced-fixed-point-error-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-computing-advanced-simplified-floating-format-v2.webp": {
    "width": 1280,
    "height": 640,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-computing-advanced-normalisation-equivalence-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-computing-advanced-range-precision-decisions-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-steam-enthalpy-depth-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-steam-condenser-service-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-english-language-workshop.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-english-language-comparison-b-c.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-english-language-clause-boundaries.webp": {
    "width": 1280,
    "height": 720,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-fission-energy-depth-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-residual-heat-depth-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-gcse-spanish-maintain-a-ninety-word-account-when-the-constraints-change-7de8c3b7.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-gcse-spanish-develop-and-justify-a-higher-two-point-account-b524ddf2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-gas-back-work-depth-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-counterflow-recovery-depth-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-german-case-agreement.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-german-clause-bracket.webp": {
    "width": 1280,
    "height": 640,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-german-question-modality.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-german-garden-time.webp": {
    "width": 1280,
    "height": 640,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-german-destination-location.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-german-evidence-writing.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-german-higher-clauses.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-german-photo-evidence.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-german-five-bullet-lifestyle.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-german-grammar-choice-diagnosis.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-german-translation-foundation.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-german-notice-reading.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-german-reading-translation.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-german-translation-higher.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-german-higher-festival-evaluation.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-gcse-french-read-an-original-notice-for-details-contrast-and-evidence-028d20d5.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-gcse-french-translate-a-short-english-message-into-clear-french-631c3b8b.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-gcse-spanish-track-singular-and-plural-reflexive-participants-across-a-routine-f65deb63.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-gcse-spanish-sequence-actions-with-before-and-after-without-changing-the-actor-1e57a1d0.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-gcse-spanish-use-present-stem-patterns-and-modals-in-an-unfamiliar-study-plan-33ecafdb.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-gcse-spanish-read-and-produce-recognisable-derived-forms-with-honest-lexical-limits-08348861.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-geothermal-finite-source-depth-v3.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-geothermal-reservoir-depth-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-psychology-gcse-hypotheses.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-psychology-gcse-variables.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-psychology-gcse-sampling.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-psychology-gcse-designs.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-psychology-gcse-settings.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-psychology-gcse-observations.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-psychology-gcse-ethics.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-psychology-gcse-descriptive.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-psychology-design-v2.webp": {
    "width": 1536,
    "height": 1024,
    "widths": [160, 640, 1536]
  },
  "/assets/lesson-psychology-statistics-v1.webp": {
    "width": 1536,
    "height": 1024,
    "widths": [160, 640, 1536]
  },
  "/assets/lesson-psychology-conformity-v1.webp": {
    "width": 1536,
    "height": 1024,
    "widths": [160, 640, 1536]
  },
  "/assets/lesson-psychology-obedience-v2.webp": {
    "width": 1536,
    "height": 1024,
    "widths": [160, 640, 1536]
  },
  "/assets/lesson-psychology-stores-v1.webp": {
    "width": 1536,
    "height": 1024,
    "widths": [160, 640, 1536]
  },
  "/assets/lesson-psychology-working-v1.webp": {
    "width": 1536,
    "height": 1024,
    "widths": [160, 640, 1536]
  },
  "/assets/lesson-psychology-retrieval-v1.webp": {
    "width": 1536,
    "height": 1024,
    "widths": [160, 640, 1536]
  },
  "/assets/lesson-psychology-eyewitness-v2.webp": {
    "width": 1536,
    "height": 1024,
    "widths": [160, 640, 1536]
  },
  "/assets/lesson-engineering-biogas-material-yield-depth-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-biogas-counterfactual-depth-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-history-hastings-cohesion-v2.webp": {
    "width": 1536,
    "height": 1024,
    "widths": [160, 640, 1536]
  },
  "/assets/lesson-history-care-evidence-v1.webp": {
    "width": 1536,
    "height": 1024,
    "widths": [160, 640, 1536]
  },
  "/assets/lesson-history-succession-criteria-v2.webp": {
    "width": 1536,
    "height": 1024,
    "widths": [160, 640, 1536]
  },
  "/assets/lesson-history-consolidation-logistics-v2.webp": {
    "width": 1536,
    "height": 1024,
    "widths": [160, 640, 1536]
  },
  "/assets/lesson-history-real-value-v1.webp": {
    "width": 1536,
    "height": 1024,
    "widths": [160, 640, 1536]
  },
  "/assets/lesson-history-interpretation-scope-v1.webp": {
    "width": 1536,
    "height": 1024,
    "widths": [160, 640, 1536]
  },
  "/assets/lesson-history-peace-criteria-v1.webp": {
    "width": 1536,
    "height": 1024,
    "widths": [160, 640, 1536]
  },
  "/assets/lesson-history-covenant-design-v1.webp": {
    "width": 1536,
    "height": 1024,
    "widths": [160, 640, 1536]
  },
  "/assets/lesson-history-humours-model-v1.webp": {
    "width": 1536,
    "height": 1024,
    "widths": [160, 640, 1536]
  },
  "/assets/lesson-history-weimar-routes-v2.webp": {
    "width": 1536,
    "height": 1024,
    "widths": [160, 640, 1536]
  },
  "/assets/lesson-gcse-psychology-correlation-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-gcse-psychology-memory-types-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-gcse-psychology-serial-position-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-gcse-psychology-reconstruction-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-gcse-psychology-depth-cues-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-gcse-psychology-perceptual-theories-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-gcse-psychology-development-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-gcse-psychology-learning-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-business-costs-depth-v2.webp": {
    "width": 1536,
    "height": 1024,
    "widths": [160, 640, 1536]
  },
  "/assets/lesson-business-profit-depth-v2.webp": {
    "width": 1536,
    "height": 1024,
    "widths": [160, 640, 1536]
  },
  "/assets/lesson-business-cashflow-depth-v2.webp": {
    "width": 1536,
    "height": 1024,
    "widths": [160, 640, 1536]
  },
  "/assets/lesson-business-cash-solutions-depth-v2.webp": {
    "width": 1536,
    "height": 1024,
    "widths": [160, 640, 1536]
  },
  "/assets/lesson-business-finance-depth-v2.webp": {
    "width": 1536,
    "height": 1024,
    "widths": [160, 640, 1536]
  },
  "/assets/lesson-business-investment-depth-v2.webp": {
    "width": 1536,
    "height": 1024,
    "widths": [160, 640, 1536]
  },
  "/assets/lesson-business-enterprise.webp": {
    "width": 1254,
    "height": 1254,
    "widths": [160, 640, 1254]
  },
  "/assets/lesson-business-stakeholders.webp": {
    "width": 1254,
    "height": 1254,
    "widths": [160, 640, 1254]
  },
  "/assets/lesson-business-breakeven.webp": {
    "width": 1254,
    "height": 1254,
    "widths": [160, 640, 1254]
  },
  "/assets/lesson-business-interest.webp": {
    "width": 1254,
    "height": 1254,
    "widths": [160, 640, 1254]
  },
  "/assets/lesson-business-operations.webp": {
    "width": 1254,
    "height": 1254,
    "widths": [160, 640, 1254]
  },
  "/assets/lesson-geography-basin.webp": {
    "width": 1536,
    "height": 1024,
    "widths": [160, 640, 1536]
  },
  "/assets/lesson-geography-carbon.webp": {
    "width": 1536,
    "height": 1024,
    "widths": [160, 640, 1536]
  },
  "/assets/lesson-geography-coast.webp": {
    "width": 1536,
    "height": 1024,
    "widths": [160, 640, 1536]
  },
  "/assets/lesson-geography-feedback.webp": {
    "width": 1536,
    "height": 1024,
    "widths": [160, 640, 1536]
  },
  "/assets/lesson-geography-measurement.webp": {
    "width": 1536,
    "height": 1024,
    "widths": [160, 640, 1536]
  },
  "/assets/lesson-geography-urban.webp": {
    "width": 1536,
    "height": 1024,
    "widths": [160, 640, 1536]
  },
  "/assets/lesson-engineering-csp-receiver-depth-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-csp-dispatch-depth-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-transformer-load-depth-v3.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-transformer-profile-depth-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-transmission-ac-depth-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-transmission-thermal-depth-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-a-level-english-literature-courtship-as-testimony-othello-1-3-227695e4.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-a-level-english-literature-how-implication-becomes-proof-othello-3-3-283a4f7a.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-a-level-english-literature-women-s-voices-before-the-ending-othello-4-3-9c532be4.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-a-level-english-literature-who-controls-the-final-account-othello-5-2-077d7a37.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-a-level-english-literature-constancy-under-pressure-sonnet116-e1102980.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-a-level-english-literature-when-love-releases-its-demand-remember-b3e7a044.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-a-level-english-literature-persuasion-regret-and-the-judgement-of-narrators-e90df2e9.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-a-level-english-literature-a-conversation-a-letter-and-changing-authority-persuasion23-e64695f7.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-protection-exposure-depth-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-outage-accounting-depth-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-rs-source-argument-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-rs-oneness-v3.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/lesson-rs-grace-v2.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/lesson-rs-authority-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-rs-baptism-v2.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/lesson-rs-prayer-v3.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/lesson-rs-zakah-v2.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/lesson-rs-marriage-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-rs-war-v2.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/lesson-rs-punishment-aims-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-a-level-religious-studies-proof-interpretation-and-faith-54784423.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-a-level-religious-studies-paley-and-the-limits-of-analogy-5638eed6.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-a-level-religious-studies-anselm-gaunilo-and-existence-0afd497a.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-a-level-religious-studies-aquinas-third-way-and-necessary-existence-18bb237a.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-a-level-religious-studies-logical-and-evidential-evil-290dab0e.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-a-level-religious-studies-natural-law-intention-and-consequences-63e38ffa.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-a-level-religious-studies-bible-church-and-interpreted-authority-033011cb.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-a-level-religious-studies-faith-in-dialogue-with-philosophical-criticism-84cc2b09.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-aluminium-charge-depth-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-aluminium-recycling-depth-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-further-maths-induction-series-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-further-maths-induction-matrix-powers-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-further-maths-complex-arithmetic-roots-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-further-maths-argand-loci-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-further-maths-de-moivre-roots-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-further-maths-matrix-order-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-further-maths-determinant-inverse-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-further-maths-three-plane-systems-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-al-english-language-context-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-al-english-language-agency-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-al-english-language-modality-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-al-english-language-interaction-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-al-english-language-comparison-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-al-english-language-corpus-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-al-english-language-debate-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-al-english-language-inquiry-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-geology-mineral-evidence-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-geology-igneous-texture-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-geology-sediment-sorting-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-geology-metamorphic-evidence-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-geology-relative-time-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-geology-fossil-correlation-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-geology-earth-two-models-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-geology-seismic-arrivals-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-a-level-sociology-what-does-education-do-and-for-whom-e2f6762b.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-a-level-sociology-educational-differences-explaining-a-pattern-without-blaming-a-group-6cac3b5b.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-a-level-sociology-labels-expectations-and-pupil-responses-b2515508.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-a-level-sociology-numbers-and-meanings-answer-different-questions-c98ce9fa.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-a-level-sociology-sampling-and-the-people-a-survey-misses-c41af471.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-a-level-sociology-interviewing-in-a-school-access-is-not-consent-77ca6329.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-a-level-sociology-observation-visible-behaviour-and-invisible-meanings-c693198f.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-a-level-sociology-from-evidence-to-policy-a-claim-needs-a-comparison-e24db58a.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-a-level-business-an-entrepreneur-chooses-what-not-to-do-c18395df.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-a-level-business-a-business-plan-becomes-a-testable-decision-cad1b834.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-a-level-business-ownership-control-and-liability-are-different-questions-069bc18d.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-a-level-business-a-cheaper-supplier-can-have-a-more-expensive-consequence-1f2dd032.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-a-level-business-research-evidence-is-not-a-promise-of-customers-332a34ae.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-a-level-business-when-a-growing-business-loses-market-share-f5d72dd2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-a-level-business-a-price-cut-can-raise-sales-and-reduce-contribution-e8324944.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-a-level-business-break-even-is-a-boundary-not-a-guarantee-of-cash-002eeb66.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-a-level-business-choose-a-target-without-turning-a-segment-into-a-stereotype-4b8f284c.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-a-level-business-marketing-objectives-must-survive-the-capacity-test-52874ed6.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-a-level-business-a-portfolio-label-is-the-beginning-of-product-judgement-9a331b73.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-a-level-business-a-distribution-route-changes-both-margin-and-customer-service-d648973c.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-a-level-business-promotion-should-earn-a-defensible-response-a984a4bd.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-a-level-business-from-clicks-to-customers-digital-evidence-and-crm-1649040a.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-a-level-business-adapt-the-mix-across-markets-without-inventing-national-traits-772664a0.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-a-level-business-marketing-ethics-when-a-profitable-claim-misleads-03bd22ce.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering36-pattern-transfer-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering36-yield-resources-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering37-memory-transactions-v3.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering37-arithmetic-intensity-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-a-level-environmental-science-energy-balance-a-boundary-before-a-temperature-03b712d8.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-a-level-environmental-science-living-carbon-stores-uptake-is-not-permanent-removal-5ec6db0d.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-a-level-environmental-science-proxy-evidence-reconstructing-with-a-calibration-620155ff.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-a-level-environmental-science-biodiversity-counts-evenness-and-useful-functions-6d2e5622.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-a-level-environmental-science-population-change-the-same-total-can-hide-different-pressures-fb3fe7e3.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-a-level-environmental-science-habitat-conservation-area-edges-and-decisions-be2c77ab.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-a-level-environmental-science-representative-samples-weighting-before-a-conclusion-4b2dd0b0.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-a-level-environmental-science-circular-materials-recoverable-is-not-lossless-137407cb.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering38-temperature-lift-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering38-service-v3.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering39-clipping-boundaries-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering39-service-headroom-v3.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering40-terminal-energy-v2.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering40-cycle-boundaries-v3.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering41-lead-acid-stoichiometry-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering41-lead-acid-accessibility-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-a-level-history-answered-transfer-checks-dcf940e0.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-a-level-history-changed-transfer-and-answer-44995418.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-a-level-history-interpretation-practice-a-boundary-that-matters-e5e38db4.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-a-level-history-changed-transfer-with-full-answer-9a7a15f0.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-a-level-history-changed-evidence-transfer-5fc32e56.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering42-generator-service-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-physics-particle-internal-energy-depth.webp": {
    "width": 1280,
    "height": 853,
    "widths": [640, 1280],
    "detail": {
      "url": "/assets/lesson-physics-particle-internal-energy-depth-1536.webp",
      "width": 1536,
      "height": 1024,
      "sources": [
        { "url": "/assets/lesson-physics-particle-internal-energy-depth-640.webp", "width": 640 },
        { "url": "/assets/lesson-physics-particle-internal-energy-depth.webp", "width": 1280 },
        { "url": "/assets/lesson-physics-particle-internal-energy-depth-1536.webp", "width": 1536 }
      ]
    }
  },
  "/assets/lesson-physics-particle-specific-heat-depth.webp": {
    "width": 1280,
    "height": 853,
    "widths": [640, 1280],
    "detail": {
      "url": "/assets/lesson-physics-particle-specific-heat-depth-1536.webp",
      "width": 1536,
      "height": 1024,
      "sources": [
        { "url": "/assets/lesson-physics-particle-specific-heat-depth-640.webp", "width": 640 },
        { "url": "/assets/lesson-physics-particle-specific-heat-depth.webp", "width": 1280 },
        { "url": "/assets/lesson-physics-particle-specific-heat-depth-1536.webp", "width": 1536 }
      ]
    }
  },
  "/assets/lesson-physics-particle-latent-heat-depth.webp": {
    "width": 1280,
    "height": 853,
    "widths": [640, 1280],
    "detail": {
      "url": "/assets/lesson-physics-particle-latent-heat-depth-1536.webp",
      "width": 1536,
      "height": 1024,
      "sources": [
        { "url": "/assets/lesson-physics-particle-latent-heat-depth-640.webp", "width": 640 },
        { "url": "/assets/lesson-physics-particle-latent-heat-depth.webp", "width": 1280 },
        { "url": "/assets/lesson-physics-particle-latent-heat-depth-1536.webp", "width": 1536 }
      ]
    }
  },
  "/assets/lesson-physics-particle-heating-stages-depth.webp": {
    "width": 1280,
    "height": 853,
    "widths": [640, 1280],
    "detail": {
      "url": "/assets/lesson-physics-particle-heating-stages-depth-1536.webp",
      "width": 1536,
      "height": 1024,
      "sources": [
        { "url": "/assets/lesson-physics-particle-heating-stages-depth-640.webp", "width": 640 },
        { "url": "/assets/lesson-physics-particle-heating-stages-depth.webp", "width": 1280 },
        { "url": "/assets/lesson-physics-particle-heating-stages-depth-1536.webp", "width": 1536 }
      ]
    }
  },
  "/assets/lesson-physics-particle-gas-motion-depth.webp": {
    "width": 1280,
    "height": 853,
    "widths": [640, 1280],
    "detail": {
      "url": "/assets/lesson-physics-particle-gas-motion-depth-1536.webp",
      "width": 1536,
      "height": 1024,
      "sources": [
        { "url": "/assets/lesson-physics-particle-gas-motion-depth-640.webp", "width": 640 },
        { "url": "/assets/lesson-physics-particle-gas-motion-depth.webp", "width": 1280 },
        { "url": "/assets/lesson-physics-particle-gas-motion-depth-1536.webp", "width": 1536 }
      ]
    }
  },
  "/assets/lesson-physics-particle-gas-pressure-volume-depth.webp": {
    "width": 1280,
    "height": 1170,
    "widths": [640, 1280],
    "detail": {
      "url": "/assets/lesson-physics-particle-gas-pressure-volume-depth-1312.webp",
      "width": 1312,
      "height": 1199,
      "sources": [
        {
          "url": "/assets/lesson-physics-particle-gas-pressure-volume-depth-640.webp",
          "width": 640
        },
        { "url": "/assets/lesson-physics-particle-gas-pressure-volume-depth.webp", "width": 1280 },
        {
          "url": "/assets/lesson-physics-particle-gas-pressure-volume-depth-1312.webp",
          "width": 1312
        }
      ]
    }
  },
  "/assets/lesson-physics-particle-gas-compression-work-depth.webp": {
    "width": 1280,
    "height": 853,
    "widths": [640, 1280],
    "detail": {
      "url": "/assets/lesson-physics-particle-gas-compression-work-depth-1536.webp",
      "width": 1536,
      "height": 1024,
      "sources": [
        {
          "url": "/assets/lesson-physics-particle-gas-compression-work-depth-640.webp",
          "width": 640
        },
        { "url": "/assets/lesson-physics-particle-gas-compression-work-depth.webp", "width": 1280 },
        {
          "url": "/assets/lesson-physics-particle-gas-compression-work-depth-1536.webp",
          "width": 1536
        }
      ]
    }
  },
  "/assets/lesson-physics-particle-specific-heat-practical-audit-depth.webp": {
    "width": 1280,
    "height": 853,
    "widths": [640, 1280],
    "detail": {
      "url": "/assets/lesson-physics-particle-specific-heat-practical-audit-depth-1536.webp",
      "width": 1536,
      "height": 1024,
      "sources": [
        {
          "url": "/assets/lesson-physics-particle-specific-heat-practical-audit-depth-640.webp",
          "width": 640
        },
        {
          "url": "/assets/lesson-physics-particle-specific-heat-practical-audit-depth.webp",
          "width": 1280
        },
        {
          "url": "/assets/lesson-physics-particle-specific-heat-practical-audit-depth-1536.webp",
          "width": 1536
        }
      ]
    }
  },
  "/assets/lesson-engineering43-solar-community-service-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-a-level-politics-changed-case-essay-repealability-and-significance-33c84424.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-a-level-politics-changed-case-essay-dissolution-versus-prorogation-ffc34f69.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-al-chemistry-physical-enthalpy.webp": {
    "width": 1280,
    "height": 853,
    "widths": [640, 1280],
    "detail": {
      "url": "/assets/lesson-al-chemistry-physical-enthalpy-1536.webp",
      "width": 1536,
      "height": 1024,
      "sources": [
        { "url": "/assets/lesson-al-chemistry-physical-enthalpy-640.webp", "width": 640 },
        { "url": "/assets/lesson-al-chemistry-physical-enthalpy.webp", "width": 1280 },
        { "url": "/assets/lesson-al-chemistry-physical-enthalpy-1536.webp", "width": 1536 }
      ]
    }
  },
  "/assets/lesson-al-chemistry-physical-calorimetry.webp": {
    "width": 1280,
    "height": 853,
    "widths": [640, 1280],
    "detail": {
      "url": "/assets/lesson-al-chemistry-physical-calorimetry-1536.webp",
      "width": 1536,
      "height": 1024,
      "sources": [
        { "url": "/assets/lesson-al-chemistry-physical-calorimetry-640.webp", "width": 640 },
        { "url": "/assets/lesson-al-chemistry-physical-calorimetry.webp", "width": 1280 },
        { "url": "/assets/lesson-al-chemistry-physical-calorimetry-1536.webp", "width": 1536 }
      ]
    }
  },
  "/assets/lesson-al-chemistry-physical-hess.webp": {
    "width": 1280,
    "height": 853,
    "widths": [640, 1280],
    "detail": {
      "url": "/assets/lesson-al-chemistry-physical-hess-1536.webp",
      "width": 1536,
      "height": 1024,
      "sources": [
        { "url": "/assets/lesson-al-chemistry-physical-hess-640.webp", "width": 640 },
        { "url": "/assets/lesson-al-chemistry-physical-hess.webp", "width": 1280 },
        { "url": "/assets/lesson-al-chemistry-physical-hess-1536.webp", "width": 1536 }
      ]
    }
  },
  "/assets/lesson-al-chemistry-physical-mean-bonds.webp": {
    "width": 1280,
    "height": 853,
    "widths": [640, 1280],
    "detail": {
      "url": "/assets/lesson-al-chemistry-physical-mean-bonds-1536.webp",
      "width": 1536,
      "height": 1024,
      "sources": [
        { "url": "/assets/lesson-al-chemistry-physical-mean-bonds-640.webp", "width": 640 },
        { "url": "/assets/lesson-al-chemistry-physical-mean-bonds.webp", "width": 1280 },
        { "url": "/assets/lesson-al-chemistry-physical-mean-bonds-1536.webp", "width": 1536 }
      ]
    }
  },
  "/assets/lesson-al-chemistry-physical-collision-barriers.webp": {
    "width": 1280,
    "height": 853,
    "widths": [640, 1280],
    "detail": {
      "url": "/assets/lesson-al-chemistry-physical-collision-barriers-1536.webp",
      "width": 1536,
      "height": 1024,
      "sources": [
        { "url": "/assets/lesson-al-chemistry-physical-collision-barriers-640.webp", "width": 640 },
        { "url": "/assets/lesson-al-chemistry-physical-collision-barriers.webp", "width": 1280 },
        {
          "url": "/assets/lesson-al-chemistry-physical-collision-barriers-1536.webp",
          "width": 1536
        }
      ]
    }
  },
  "/assets/lesson-al-chemistry-physical-temperature-rate-evidence.webp": {
    "width": 1280,
    "height": 853,
    "widths": [640, 1280],
    "detail": {
      "url": "/assets/lesson-al-chemistry-physical-temperature-rate-evidence-1536.webp",
      "width": 1536,
      "height": 1024,
      "sources": [
        {
          "url": "/assets/lesson-al-chemistry-physical-temperature-rate-evidence-640.webp",
          "width": 640
        },
        {
          "url": "/assets/lesson-al-chemistry-physical-temperature-rate-evidence.webp",
          "width": 1280
        },
        {
          "url": "/assets/lesson-al-chemistry-physical-temperature-rate-evidence-1536.webp",
          "width": 1536
        }
      ]
    }
  },
  "/assets/lesson-al-chemistry-physical-dynamic-equilibrium.webp": {
    "width": 1280,
    "height": 853,
    "widths": [640, 1280],
    "detail": {
      "url": "/assets/lesson-al-chemistry-physical-dynamic-equilibrium-1536.webp",
      "width": 1536,
      "height": 1024,
      "sources": [
        {
          "url": "/assets/lesson-al-chemistry-physical-dynamic-equilibrium-640.webp",
          "width": 640
        },
        { "url": "/assets/lesson-al-chemistry-physical-dynamic-equilibrium.webp", "width": 1280 },
        {
          "url": "/assets/lesson-al-chemistry-physical-dynamic-equilibrium-1536.webp",
          "width": 1536
        }
      ]
    }
  },
  "/assets/lesson-al-chemistry-physical-kc-conservation.webp": {
    "width": 1280,
    "height": 853,
    "widths": [640, 1280],
    "detail": {
      "url": "/assets/lesson-al-chemistry-physical-kc-conservation-1536.webp",
      "width": 1536,
      "height": 1024,
      "sources": [
        { "url": "/assets/lesson-al-chemistry-physical-kc-conservation-640.webp", "width": 640 },
        { "url": "/assets/lesson-al-chemistry-physical-kc-conservation.webp", "width": 1280 },
        { "url": "/assets/lesson-al-chemistry-physical-kc-conservation-1536.webp", "width": 1536 }
      ]
    }
  },
  "/assets/lesson-al-physics-waves-mechanics-progressive-polarisation.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-al-physics-waves-mechanics-stationary-string.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-al-physics-waves-mechanics-two-source-interference.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-al-physics-waves-mechanics-single-slit-grating.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-al-physics-waves-mechanics-refraction-fibre.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-al-physics-waves-mechanics-forces-vectors-newton.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-al-physics-waves-mechanics-motion-graphs-projectiles.webp": {
    "width": 1280,
    "height": 640,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-al-physics-waves-mechanics-momentum-impulse.webp": {
    "width": 1280,
    "height": 640,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-al-spanish-stage.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-al-spanish-memory.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-al-spanish-relative.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-al-spanish-concession.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering44-titanium-reagent-loop-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-al-chemistry-acids-proton-transfer.webp": {
    "width": 1280,
    "height": 853,
    "widths": [640, 1280],
    "detail": {
      "url": "/assets/lesson-al-chemistry-acids-proton-transfer-1536.webp",
      "width": 1536,
      "height": 1024,
      "sources": [
        { "url": "/assets/lesson-al-chemistry-acids-proton-transfer-640.webp", "width": 640 },
        { "url": "/assets/lesson-al-chemistry-acids-proton-transfer.webp", "width": 1280 },
        { "url": "/assets/lesson-al-chemistry-acids-proton-transfer-1536.webp", "width": 1536 }
      ]
    }
  },
  "/assets/lesson-al-chemistry-acids-logarithmic-ph.webp": {
    "width": 1280,
    "height": 853,
    "widths": [640, 1280],
    "detail": {
      "url": "/assets/lesson-al-chemistry-acids-logarithmic-ph-1536.webp",
      "width": 1536,
      "height": 1024,
      "sources": [
        { "url": "/assets/lesson-al-chemistry-acids-logarithmic-ph-640.webp", "width": 640 },
        { "url": "/assets/lesson-al-chemistry-acids-logarithmic-ph.webp", "width": 1280 },
        { "url": "/assets/lesson-al-chemistry-acids-logarithmic-ph-1536.webp", "width": 1536 }
      ]
    }
  },
  "/assets/lesson-al-chemistry-acids-water-ionic-product.webp": {
    "width": 1280,
    "height": 853,
    "widths": [640, 1280],
    "detail": {
      "url": "/assets/lesson-al-chemistry-acids-water-ionic-product-1536.webp",
      "width": 1536,
      "height": 1024,
      "sources": [
        { "url": "/assets/lesson-al-chemistry-acids-water-ionic-product-640.webp", "width": 640 },
        { "url": "/assets/lesson-al-chemistry-acids-water-ionic-product.webp", "width": 1280 },
        { "url": "/assets/lesson-al-chemistry-acids-water-ionic-product-1536.webp", "width": 1536 }
      ]
    }
  },
  "/assets/lesson-al-chemistry-acids-weak-acid-inventories.webp": {
    "width": 1280,
    "height": 853,
    "widths": [640, 1280],
    "detail": {
      "url": "/assets/lesson-al-chemistry-acids-weak-acid-inventories-1536.webp",
      "width": 1536,
      "height": 1024,
      "sources": [
        { "url": "/assets/lesson-al-chemistry-acids-weak-acid-inventories-640.webp", "width": 640 },
        { "url": "/assets/lesson-al-chemistry-acids-weak-acid-inventories.webp", "width": 1280 },
        {
          "url": "/assets/lesson-al-chemistry-acids-weak-acid-inventories-1536.webp",
          "width": 1536
        }
      ]
    }
  },
  "/assets/lesson-al-chemistry-acids-titration-curves.webp": {
    "width": 1280,
    "height": 853,
    "widths": [640, 1280],
    "detail": {
      "url": "/assets/lesson-al-chemistry-acids-titration-curves-1536.webp",
      "width": 1536,
      "height": 1024,
      "sources": [
        { "url": "/assets/lesson-al-chemistry-acids-titration-curves-640.webp", "width": 640 },
        { "url": "/assets/lesson-al-chemistry-acids-titration-curves.webp", "width": 1280 },
        { "url": "/assets/lesson-al-chemistry-acids-titration-curves-1536.webp", "width": 1536 }
      ]
    }
  },
  "/assets/lesson-al-chemistry-acids-indicators-and-titres.webp": {
    "width": 1280,
    "height": 853,
    "widths": [640, 1280],
    "detail": {
      "url": "/assets/lesson-al-chemistry-acids-indicators-and-titres-1536.webp",
      "width": 1536,
      "height": 1024,
      "sources": [
        { "url": "/assets/lesson-al-chemistry-acids-indicators-and-titres-640.webp", "width": 640 },
        { "url": "/assets/lesson-al-chemistry-acids-indicators-and-titres.webp", "width": 1280 },
        {
          "url": "/assets/lesson-al-chemistry-acids-indicators-and-titres-1536.webp",
          "width": 1536
        }
      ]
    }
  },
  "/assets/lesson-al-chemistry-acids-buffer-action.webp": {
    "width": 1280,
    "height": 853,
    "widths": [640, 1280],
    "detail": {
      "url": "/assets/lesson-al-chemistry-acids-buffer-action-1536.webp",
      "width": 1536,
      "height": 1024,
      "sources": [
        { "url": "/assets/lesson-al-chemistry-acids-buffer-action-640.webp", "width": 640 },
        { "url": "/assets/lesson-al-chemistry-acids-buffer-action.webp", "width": 1280 },
        { "url": "/assets/lesson-al-chemistry-acids-buffer-action-1536.webp", "width": 1536 }
      ]
    }
  },
  "/assets/lesson-al-chemistry-acids-buffer-inventories.webp": {
    "width": 1280,
    "height": 853,
    "widths": [640, 1280],
    "detail": {
      "url": "/assets/lesson-al-chemistry-acids-buffer-inventories-1536.webp",
      "width": 1536,
      "height": 1024,
      "sources": [
        { "url": "/assets/lesson-al-chemistry-acids-buffer-inventories-640.webp", "width": 640 },
        { "url": "/assets/lesson-al-chemistry-acids-buffer-inventories.webp", "width": 1280 },
        { "url": "/assets/lesson-al-chemistry-acids-buffer-inventories-1536.webp", "width": 1536 }
      ]
    }
  },
  "/assets/lesson-maths-differentiation-rational.webp": {
    "width": 1280,
    "height": 853,
    "widths": [640, 1280],
    "detail": {
      "url": "/assets/lesson-maths-differentiation-rational-1536.webp",
      "width": 1536,
      "height": 1024,
      "sources": [
        { "url": "/assets/lesson-maths-differentiation-rational-640.webp", "width": 640 },
        { "url": "/assets/lesson-maths-differentiation-rational.webp", "width": 1280 },
        { "url": "/assets/lesson-maths-differentiation-rational-1536.webp", "width": 1536 }
      ]
    }
  },
  "/assets/lesson-maths-differentiation-scaled.webp": {
    "width": 1280,
    "height": 853,
    "widths": [640, 1280],
    "detail": {
      "url": "/assets/lesson-maths-differentiation-scaled-1536.webp",
      "width": 1536,
      "height": 1024,
      "sources": [
        { "url": "/assets/lesson-maths-differentiation-scaled-640.webp", "width": 640 },
        { "url": "/assets/lesson-maths-differentiation-scaled.webp", "width": 1280 },
        { "url": "/assets/lesson-maths-differentiation-scaled-1536.webp", "width": 1536 }
      ]
    }
  },
  "/assets/lesson-maths-differentiation-optimisation.webp": {
    "width": 1280,
    "height": 853,
    "widths": [640, 1280],
    "detail": {
      "url": "/assets/lesson-maths-differentiation-optimisation-1536.webp",
      "width": 1536,
      "height": 1024,
      "sources": [
        { "url": "/assets/lesson-maths-differentiation-optimisation-640.webp", "width": 640 },
        { "url": "/assets/lesson-maths-differentiation-optimisation.webp", "width": 1280 },
        { "url": "/assets/lesson-maths-differentiation-optimisation-1536.webp", "width": 1536 }
      ]
    }
  },
  "/assets/lesson-maths-differentiation-rules.webp": {
    "width": 1280,
    "height": 853,
    "widths": [640, 1280],
    "detail": {
      "url": "/assets/lesson-maths-differentiation-rules-1536.webp",
      "width": 1536,
      "height": 1024,
      "sources": [
        { "url": "/assets/lesson-maths-differentiation-rules-640.webp", "width": 640 },
        { "url": "/assets/lesson-maths-differentiation-rules.webp", "width": 1280 },
        { "url": "/assets/lesson-maths-differentiation-rules-1536.webp", "width": 1536 }
      ]
    }
  },
  "/assets/lesson-maths-differentiation-inverse.webp": {
    "width": 1280,
    "height": 853,
    "widths": [640, 1280],
    "detail": {
      "url": "/assets/lesson-maths-differentiation-inverse-1536.webp",
      "width": 1536,
      "height": 1024,
      "sources": [
        { "url": "/assets/lesson-maths-differentiation-inverse-640.webp", "width": 640 },
        { "url": "/assets/lesson-maths-differentiation-inverse.webp", "width": 1280 },
        { "url": "/assets/lesson-maths-differentiation-inverse-1536.webp", "width": 1536 }
      ]
    }
  },
  "/assets/lesson-maths-differentiation-rates.webp": {
    "width": 1280,
    "height": 853,
    "widths": [640, 1280],
    "detail": {
      "url": "/assets/lesson-maths-differentiation-rates-1536.webp",
      "width": 1536,
      "height": 1024,
      "sources": [
        { "url": "/assets/lesson-maths-differentiation-rates-640.webp", "width": 640 },
        { "url": "/assets/lesson-maths-differentiation-rates.webp", "width": 1280 },
        { "url": "/assets/lesson-maths-differentiation-rates-1536.webp", "width": 1536 }
      ]
    }
  },
  "/assets/lesson-maths-differentiation-implicit.webp": {
    "width": 1280,
    "height": 853,
    "widths": [640, 1280],
    "detail": {
      "url": "/assets/lesson-maths-differentiation-implicit-1536.webp",
      "width": 1536,
      "height": 1024,
      "sources": [
        { "url": "/assets/lesson-maths-differentiation-implicit-640.webp", "width": 640 },
        { "url": "/assets/lesson-maths-differentiation-implicit.webp", "width": 1280 },
        { "url": "/assets/lesson-maths-differentiation-implicit-1536.webp", "width": 1536 }
      ]
    }
  },
  "/assets/lesson-maths-differentiation-parametric.webp": {
    "width": 1280,
    "height": 853,
    "widths": [640, 1280],
    "detail": {
      "url": "/assets/lesson-maths-differentiation-parametric-1536.webp",
      "width": 1536,
      "height": 1024,
      "sources": [
        { "url": "/assets/lesson-maths-differentiation-parametric-640.webp", "width": 640 },
        { "url": "/assets/lesson-maths-differentiation-parametric.webp", "width": 1280 },
        { "url": "/assets/lesson-maths-differentiation-parametric-1536.webp", "width": 1536 }
      ]
    }
  },
  "/assets/lesson-maths-gradient-graph-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-maths-trig-first-principles-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-al-french-articles-reference.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-al-french-pronoun-chain.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-al-french-past-timeline.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-al-french-conditions-completion.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-al-french-subjunctive-timeline.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-al-french-passive-causative.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-al-french-reported-questions.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-al-french-argument-evidence.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-al-french-france-digital-skills.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-al-french-canada-volunteering.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-al-french-belgium-election-2024.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-al-french-saint-louis-living-heritage.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-al-french-tartuffe-selected-exchange.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-al-french-candide-opening-contrast.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-al-french-translation-digital-service.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-al-french-translation-heritage-proposal.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-ro-service-depth-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-steel-boundary-depth-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-cmos-event-depth-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-packet-schedule-depth-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-ultrasound-acquisition-depth-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-diffusion-moment-depth-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-maths-integration-foundations.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-maths-area-nonlinear-boundaries.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-maths-substitution-domain-limits.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-al-computing-addressing-depth.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-al-computing-interrupt-depth.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-al-computing-cache-depth.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-pumped-variable-head-depth-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-gcse-physics-half-life-background.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-al-physics-young-modulus.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-engineering-storage-alignment-depth-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-geometry-pythagoras-area-proof-v1.webp": {
    "width": 1254,
    "height": 1254,
    "widths": [160, 640, 1254]
  },
  "/assets/lesson-pearson-1ma1-geometry-translation-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-geometry-off-origin-rotation-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-geometry-axis-reflection-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-geometry-diagonal-reflection-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-geometry-positive-enlargement-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-geometry-fractional-enlargement-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-geometry-negative-enlargement-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-geometry-enlargement-centre-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-gcse-chemistry-rate-depth.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-gcse-chemistry-comparison-depth.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-gcse-chemistry-dynamic-depth.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-gcse-chemistry-conditions-depth.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-geometry-combined-translations-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-geometry-parallel-reflections-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-geometry-rotation-translation-centre-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-geometry-reverse-transformation-route-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-gcse-chemistry-organic-alkanes-depth.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-gcse-chemistry-organic-fractions-depth.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-gcse-chemistry-organic-combustion-depth.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-gcse-chemistry-organic-cracking-depth.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-geometry-circle-fixed-distance-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-geometry-circle-contact-counts-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-geometry-circle-arcs-sectors-segments-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-geometry-circle-angle-proof-cases-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-geometry-circle-chord-tangent-rhs-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-pearson-1ma1-geometry-coordinate-quadrilateral-reconstruction-v1.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-carol-depth-01.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-carol-depth-02.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-carol-depth-03.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-carol-depth-04.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-carol-depth-05.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-carol-depth-06.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-carol-depth-07.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/lesson-carol-depth-08.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/travel-100-edinburgh.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/travel-100-granada.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/travel-100-hoi-an.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/travel-100-petra.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/travel-100-zanzibar.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/travel-100-quito.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/travel-100-lisbon.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/travel-100-marrakesh.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/travel-100-angkor.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/travel-100-banff.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/travel-100-wadi-rum.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/travel-100-sydney.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/travel-100-prague.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/travel-100-budapest.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/travel-100-luang-prabang.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/travel-100-rapa-nui.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/travel-100-machu-picchu.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/travel-100-chichen-itza.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/travel-100-fes.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/travel-100-luxor.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/travel-100-chicago.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/travel-100-oaxaca.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/travel-100-tongariro.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/travel-100-levuka.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/travel-100-seoul.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/travel-100-singapore.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/travel-100-hong-kong.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/travel-100-beijing.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/travel-100-borobudur.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/travel-100-yogyakarta.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/travel-100-porto.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/travel-100-bergen.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/travel-100-okavango.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/travel-100-namib.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/travel-100-yosemite.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/travel-100-blue-mountains.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/travel-100-london.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/travel-100-amsterdam.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/travel-100-cairo.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/travel-100-abu-simbel.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/travel-100-washington-dc.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/travel-100-new-orleans.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/travel-100-kathmandu.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/travel-100-jaipur.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/travel-100-lalibela.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/travel-100-goree.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/travel-100-havana.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/travel-100-cartagena.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/travel-100-vienna.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/travel-100-krakow.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/travel-100-barcelona.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/travel-100-seville.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/travel-100-dubrovnik.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/travel-100-mont-saint-michel.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/travel-100-tunis-carthage.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/travel-100-serengeti.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/travel-100-ngorongoro.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/travel-100-mauritius.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/travel-100-reykjavik.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/travel-100-quebec-city.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/travel-100-hanoi.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/travel-100-bangkok.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/travel-100-varanasi.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/travel-100-sigiriya.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/travel-100-galle.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/travel-100-samarkand.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/travel-100-antigua-guatemala.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/travel-100-cusco.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/travel-100-rio-de-janeiro.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/travel-100-buenos-aires.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/travel-100-valparaiso.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/travel-100-torres-del-paine.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/travel-100-kakadu.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/travel-100-tasmanian-wilderness.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/travel-100-ningaloo.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/travel-100-abel-tasman.webp": {
    "width": 1280,
    "height": 853,
    "widths": [160, 640, 1280]
  },
  "/assets/alpine.png": { "width": 1448, "height": 1086, "widths": [160, 640, 1280] },
  "/assets/amalfi.png": { "width": 1448, "height": 1086, "widths": [160, 640, 1280] },
  "/assets/energized-story-01-dawn.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/energized-story-02-ready-desk.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/energized-story-03-garden-path.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/energized-story-04-first-mark.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/feeling-calm-rainforest.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/gallery-ancient-egypt-giza-casing.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-ancient-egypt-nile-transport.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-ancient-egypt-saqqara-complex.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-ancient-egypt-stone-workers.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-ancient-india-courtyard-drain.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-ancient-india-great-bath.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-ancient-india-indus-street.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-ancient-india-indus-workshop.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-ancient-wonders-artemis-colonnade.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-ancient-wonders-mausoleum-terraces.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-ancient-wonders-olympia-temple.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-ancient-wonders-pharos-harbor.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-astrology-babylonian-sky.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-astrology-celestial-map.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-astrology-moon-journal.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-astrology-zodiac-wheel.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-astronomy-milky-way-night.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-astronomy-moon-observation.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-astronomy-observatory-dusk.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-astronomy-planet-transit.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-biology-fern-life.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-biology-leaf-stomata.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-biology-mushroom-network.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-biology-pollinator-garden.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-budget-recipes-beans-toast.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-budget-recipes-chickpea-salad.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-budget-recipes-lentil-pot.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-budget-recipes-vegetable-rice.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-chemistry-colored-solutions.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-chemistry-crystal-facets.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-chemistry-rusted-iron.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-chemistry-water-droplet.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-chicago-crown-fountain.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-chicago-lakefront-path.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-chicago-prairie-interior.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-chicago-riverwalk-morning.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-classical-greece-agora-walk.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-classical-greece-greek-vessels.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-classical-greece-marble-carving.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-classical-greece-theatre-hillside.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-coding-connected-nodes.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-coding-paper-prototype.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-coding-quiet-workstation.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-coding-sorting-cards.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-design-photography-color-papers.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-design-photography-negative-space.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-design-photography-street-reflections.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-design-photography-window-shadows.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-earth-climate-basalt-columns.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-earth-climate-cloud-water.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-earth-climate-glacier-valley.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-earth-climate-river-meander.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-engineering-gear-train.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-engineering-prototype-workbench.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-engineering-truss-bridge.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-engineering-wind-turbine.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-europe-by-rail-alpine-carriage.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-europe-by-rail-coastal-rail.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-europe-by-rail-small-town-stop.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-europe-by-rail-station-morning.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-food-bread-and-butter.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-food-citrus-dessert.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-food-market-tomatoes.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-food-roasted-vegetables.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-imperial-china-han-courtyard.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-imperial-china-han-lacquer.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-imperial-china-silk-workshop.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-imperial-china-tomb-models.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-maths-curve-in-nature.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-maths-shadows-and-shapes.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-maths-staircase-pattern.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-maths-tiles-and-symmetry.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-maya-cities-maya-courtyard.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-maya-cities-maya-stela.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-maya-cities-maya-water.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-maya-cities-tikal-plaza.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-mesopotamia-canal-fields.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-mesopotamia-ishtar-bricks.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-mesopotamia-tablet-account.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-mesopotamia-ziggurat-steps.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-physics-pendulum-light.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-physics-prism-spectrum.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-physics-water-ripples.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-physics-wheel-and-shadow.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-roman-empire-aqueduct-valley.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-roman-empire-forum-colonnade.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-roman-empire-roman-courtyard.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-roman-empire-roman-workshop.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-space-lunar-rim.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-space-mars-delta.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-space-orbital-earth.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-space-stellar-nursery.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-study-lab-flashcards.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-study-lab-one-page-notes.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-study-lab-study-break.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-study-lab-worked-example.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-world-kitchens-fermentation-jars.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-world-kitchens-noodle-bowl.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-world-kitchens-shared-flatbread.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/gallery-world-kitchens-spice-market.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/game-arcade-atrium-v1.png": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/game-arcade-jewel-burst-v1.png": {
    "width": 1774,
    "height": 887,
    "widths": [160, 640, 1774]
  },
  "/assets/game-arcade-prizes-v1.webp": {
    "width": 1024,
    "height": 1024,
    "widths": [160, 640, 1024]
  },
  "/assets/game-arcade-puzzle-emblems-v1.png": {
    "width": 1774,
    "height": 887,
    "widths": [160, 640, 1774]
  },
  "/assets/game-bob-01-v1.png": { "width": 1024, "height": 1536, "widths": [160, 640, 1024] },
  "/assets/game-bob-02-v1.png": { "width": 1024, "height": 1536, "widths": [160, 640, 1024] },
  "/assets/game-bob-03-v1.png": { "width": 1024, "height": 1536, "widths": [160, 640, 1024] },
  "/assets/game-bob-04-v1.png": { "width": 1024, "height": 1536, "widths": [160, 640, 1024] },
  "/assets/game-bob-05-v1.png": { "width": 1024, "height": 1536, "widths": [160, 640, 1024] },
  "/assets/game-bob-06-v1.png": { "width": 1024, "height": 1536, "widths": [160, 640, 1024] },
  "/assets/game-bob-07-v1.png": { "width": 1024, "height": 1536, "widths": [160, 640, 1024] },
  "/assets/game-bob-08-v1.png": { "width": 1024, "height": 1536, "widths": [160, 640, 1024] },
  "/assets/game-bob-09-v1.png": { "width": 1024, "height": 1536, "widths": [160, 640, 1024] },
  "/assets/game-bob-10-v1.png": { "width": 1024, "height": 1536, "widths": [160, 640, 1024] },
  "/assets/game-bob-11-v1.png": { "width": 1024, "height": 1536, "widths": [160, 640, 1024] },
  "/assets/game-bob-12-v1.png": { "width": 1024, "height": 1536, "widths": [160, 640, 1024] },
  "/assets/game-bob-13-v1.png": { "width": 1024, "height": 1536, "widths": [160, 640, 1024] },
  "/assets/game-bob-14-v1.png": { "width": 1024, "height": 1536, "widths": [160, 640, 1024] },
  "/assets/game-bob-15-v1.png": { "width": 1024, "height": 1536, "widths": [160, 640, 1024] },
  "/assets/game-bob-16-v1.png": { "width": 1024, "height": 1536, "widths": [160, 640, 1024] },
  "/assets/game-bob-17-v1.png": { "width": 1024, "height": 1536, "widths": [160, 640, 1024] },
  "/assets/game-bob-18-v1.png": { "width": 1024, "height": 1536, "widths": [160, 640, 1024] },
  "/assets/game-bob-19-v1.png": { "width": 1024, "height": 1536, "widths": [160, 640, 1024] },
  "/assets/game-bob-20-v1.png": { "width": 1024, "height": 1536, "widths": [160, 640, 1024] },
  "/assets/game-brook-glade-v1.png": { "width": 1024, "height": 1536, "widths": [160, 640, 1024] },
  "/assets/game-bubble-burst-v2.webp": {
    "width": 1152,
    "height": 1152,
    "widths": [160, 640, 1152]
  },
  "/assets/game-bubble-grove-world-v1.png": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/game-bubble-grove-world-v2.webp": {
    "width": 960,
    "height": 1440,
    "widths": [160, 640, 960]
  },
  "/assets/game-bubble-materials-v2.webp": {
    "width": 1152,
    "height": 768,
    "widths": [160, 640, 1152]
  },
  "/assets/game-craft-arcade-emblems-v1.png": {
    "width": 2172,
    "height": 724,
    "widths": [160, 640, 2172]
  },
  "/assets/game-hidden-friends-characters-v1.png": {
    "width": 1774,
    "height": 887,
    "widths": [160, 640, 1774]
  },
  "/assets/game-marble-burst-v1.webp": { "width": 1024, "height": 512, "widths": [160, 640, 1024] },
  "/assets/game-marble-observatory-v1.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/game-orchard-bloom-burst-v1.webp": {
    "width": 1152,
    "height": 1152,
    "widths": [160, 640, 1152]
  },
  "/assets/game-orchard-charms-v1.webp": {
    "width": 1536,
    "height": 1024,
    "widths": [160, 640, 1536]
  },
  "/assets/game-orchard-daylight-v1.webp": {
    "width": 1536,
    "height": 1024,
    "widths": [160, 640, 1536]
  },
  "/assets/game-orchard-jewels-v1.png": {
    "width": 1536,
    "height": 1024,
    "widths": [160, 640, 1536]
  },
  "/assets/game-orchard-powers-v1.png": {
    "width": 1774,
    "height": 887,
    "widths": [160, 640, 1774]
  },
  "/assets/game-orchard-rush-background-v1.png": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/game-orchard-rush-fruits-v1.png": {
    "width": 1254,
    "height": 1254,
    "widths": [160, 640, 1254]
  },
  "/assets/game-orchard-worlds-v1.png": {
    "width": 1536,
    "height": 1024,
    "widths": [160, 640, 1536]
  },
  "/assets/game-pocket-parade-v1.png": {
    "width": 1254,
    "height": 1254,
    "widths": [160, 640, 1254]
  },
  "/assets/game-prism-sanctuary-v1.png": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/game-velvet-observatory-world-v1.png": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/game-waterworks-foundry-v1.png": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/google-g.png": { "width": 200, "height": 204, "widths": [160, 200] },
  "/assets/history-bio-abraham-lincoln.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/history-bio-ba-trieu.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/history-bio-basil-ii.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/history-bio-cleopatra-vii.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/history-bio-cyrus-ii.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/history-bio-elizabeth-i.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/history-bio-frederick-barbarossa.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/history-bio-gandhi.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/history-bio-gorgo.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/history-bio-hojo-tokimune.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/history-bio-julius-caesar.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/history-bio-ludwig-ii.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/history-bio-menelik-ii.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/history-bio-nader-shah.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/history-bio-nzinga-mbande.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/history-bio-poundmaker.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/history-bio-sundiata-keita.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/history-bio-theodore-roosevelt.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/history-bio-victoria.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/history-bio-wilhelmina.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/history-bio-wu-zetian.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/history-bio-yongle.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/history-reading-babylon.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/history-reading-china.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/history-reading-egypt.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/history-reading-greek-worlds.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/history-reading-indian-worlds.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/history-reading-korean-worlds.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/history-reading-maya.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/history-reading-rome.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/history-reading-sumer.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/inspired-story-01-notice.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/inspired-story-02-imagine.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/inspired-story-03-connect.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/inspired-story-04-keep.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/kyoto.png": { "width": 1536, "height": 1024, "widths": [160, 640, 1280] },
  "/assets/lifestyle-amusing-animals-001-the-opening-bow.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-002-an-important-leaf.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-003-the-cushion-committee.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-004-ears-on-the-breeze.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-005-the-spare-seat.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-006-return-to-sender.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-007-long-dog-short-meeting.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-008-a-very-local-expedition.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-009-one-ball-two-opinions.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-010-the-rain-check-window.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-011-paws-before-applause.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-012-a-blanket-corner-claimed.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-013-a-nose-for-the-story.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-014-tiny-dog-grand-entrance.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-015-the-gentle-snowplough.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-016-bed-with-a-view.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-017-the-crooked-little-portrait.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-018-a-soft-summit.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-019-the-turn-around.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-020-the-hallway-escort.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-021-the-larger-shadow.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-022-the-toy-census.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-023-a-beautifully-inefficient-shortcut.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-024-the-floor-level-greeting.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-025-the-corner-of-sunshine.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-026-a-pebble-audience.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-027-the-ear-that-stayed-behind.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-028-ball-under-observation.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-029-the-first-dry-paw.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-030-fluff-at-the-threshold.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-031-the-good-side-again.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-032-a-leaf-in-the-wake.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-033-the-broadest-welcome.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-034-the-missing-half-of-the-bed.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-035-the-pause-between-bounces.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-036-the-green-room-guest.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-037-a-serious-patch-of-moss.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-038-the-upside-down-afternoon.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-039-a-stripe-for-company.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-040-the-lawn-side-handover.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-041-the-very-wide-blink.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-042-a-nose-around-the-corner.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-043-the-featherweight-parcel.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-044-the-level-playing-field.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-045-the-blanket-inspection.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-046-the-sandy-fringe.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-047-two-noses-one-breeze.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-048-the-perfectly-placed-chin.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-049-the-briefest-airborne-ear.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-050-a-window-fully-occupied.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-051-the-freshly-discovered-room.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-052-the-nose-to-nose-pause.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-053-the-long-view.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-054-a-ball-shaped-question.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-055-the-quiet-co-pilot.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-056-the-rug-side-roll.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-057-the-soft-toy-lookout.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-058-a-breeze-proof-hairstyle.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-059-the-two-bed-solution.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-060-the-rose-garden-route.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-061-the-toy-s-dramatic-return.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-062-the-tiny-sun-trap.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-063-the-grass-moustache.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-064-the-excellent-detour.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-065-the-afternoon-bookend.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-066-the-rug-s-new-outline.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-067-the-low-garden-inspector.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-068-the-homeward-trot.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-069-the-unhurried-queue.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-070-the-ball-s-convenient-address.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-071-a-cloud-on-four-paws.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-072-the-generous-elbow-room.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-073-the-softened-silhouette.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-074-the-puppy-sized-committee.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-075-a-nose-in-the-folds.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-076-the-straight-line-exception.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-077-the-well-supported-ear.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-078-the-small-balcony-audience.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-079-the-ball-beside-the-blanket.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-080-the-brave-little-trot.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-081-a-pair-of-lawn-bookends.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-082-the-dog-s-eye-gallery.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-083-the-corner-turning-ears.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-084-the-remarkable-pillow-shortage.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-085-the-little-garden-interruption.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-086-the-softest-landing-strip.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-087-the-world-s-smaller-patrol.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-088-the-afternoon-stretch.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-089-the-extremely-broad-corridor.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-090-one-step-into-spring.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-091-the-low-sofa-lookout.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-092-the-shared-toy-catalogue.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-093-a-very-short-lap.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-094-the-window-ledge-inspector.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-095-the-toy-with-travelling-ears.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-096-the-quietest-guardrail.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-097-the-small-pile-of-afternoon.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-098-the-polite-approach.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-099-the-cloud-coloured-curl.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-100-the-back-garden-panorama.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-101-a-toy-on-the-doorstep.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-102-the-marble-floor-masterpiece.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-103-the-fragrant-border-report.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-104-the-lawn-s-visiting-curl.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-105-the-nose-shaped-bookmark.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-106-the-side-by-side-departure.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-107-the-toy-s-hiding-place.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-108-the-fluffier-furniture-leg.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-109-the-light-footed-loop.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-110-the-coat-s-own-horizon.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-111-the-unclaimed-cushion.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-112-the-small-green-mystery.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-113-the-long-nosed-afternoon.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-114-the-empty-chair-understudy.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-115-the-ball-s-shadow-duet.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-116-the-bright-eyed-intermission.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-117-the-handsome-hallway-curve.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-118-the-little-nose-big-lawn.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-119-the-softest-sort-of-delivery.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-120-the-garden-s-white-comma.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-121-the-wide-eyed-toy-debut.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-122-the-familiar-floor-duet.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-123-the-last-little-bounce.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-124-the-porch-s-patient-portrait.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-125-the-official-blanket-occupant.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-126-the-small-returning-parade.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-127-the-excellent-place-to-stop.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-128-the-nose-led-invitation.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-129-the-room-s-gentle-centre.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-130-the-companionable-horizon.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-131-the-box-has-a-resident.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-132-two-ears-in-the-doorway.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-133-packing-material-unpacked.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-134-window-seat-committee.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-135-the-cushion-crater.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-136-one-paw-pending.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-137-chair-or-cat.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-138-the-rug-has-a-wrinkle.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-139-low-level-lookout.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-140-the-tunnel-greeting.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-141-sunbeam-shaped-afternoon.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-142-ball-under-review.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-143-cardboard-penthouse-ground-floor.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-144-a-tail-in-the-frame.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-145-soft-landing-serious-face.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-146-curtain-side-resident.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-147-the-beds-smallest-corner.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-148-welcome-to-the-scratch-lounge.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-149-pebble-sized-supervisor.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-150-the-folded-blanket-question.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-151-no-room-for-the-paperwork.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-152-the-sideways-entrance.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-153-little-paws-big-pause.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-154-the-blanket-kneading-board.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-155-a-chin-on-the-edge.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-156-room-for-a-second-thought.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-157-rug-edge-goalkeeping.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-158-the-armchair-waterfall.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-159-cloud-on-the-ottoman.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-160-the-first-gentle-tackle.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-161-the-doorway-loaf.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-162-a-modest-toy-parade.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-163-the-empty-basket-audition.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-164-the-neighbourly-head-tilt.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-165-the-tassel-free-blanket-club.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-166-the-round-toy-detour.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-167-one-ear-behind-the-cushion.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-168-the-nap-has-an-extension.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-169-the-scratching-post-embrace.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-170-the-hallway-reception.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-171-soft-toy-sideways-opinion.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-172-the-towel-mountain.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-173-the-paper-arch-inspector.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-174-the-sleeping-comma.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-175-the-wide-eyed-introduction.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-176-the-chair-leg-expedition.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-177-the-quiet-double-curl.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-178-the-toy-has-escaped-by-inches.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-179-the-blanket-ridge-patrol.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-180-the-cushion-sandwich.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-181-the-low-shelf-curator.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-182-the-large-mouse-meeting.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-183-a-paw-through-the-tunnel.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-184-the-tilted-loaf.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-185-the-sunny-cheek-rest.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-186-the-scratchers-little-balcony.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-187-the-soft-ball-stalemate.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-188-the-blankets-new-handle.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-189-the-corner-with-whiskers.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-190-the-plush-fish-inspection.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-191-the-garden-room-guest.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-192-the-yawn-before-lunch.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-193-the-shoulder-wash-break.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-194-the-scratch-and-stretch-duet.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-195-the-ball-behind-the-bend.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-196-the-low-bench-takeover.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-197-the-blanket-weather-report.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-198-the-cardboard-terrace.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-199-the-ripple-in-the-rug.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-200-the-moss-green-hammock.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-201-the-plush-carrot-council.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-202-the-whisker-level-portrait.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-203-the-fabric-cave-visitor.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-204-the-long-stretch-on-the-mat.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-205-the-toy-basket-auditor.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-206-the-blanket-peninsula.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-207-the-silent-window-commentary.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-208-the-round-bed-geometry.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-209-the-paw-print-rehearsal.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-210-the-cardboard-window.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-211-the-cosy-zigzag.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-212-the-toys-return-address.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-213-the-afternoon-chin-shelf.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-214-the-serious-cardboard-scratch.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-215-the-mats-little-question.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-216-the-enclosed-patio-pause.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-217-the-cushions-uneven-crown.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-218-the-toy-tunnel-traffic.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-219-the-paw-on-the-patch.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-220-the-soft-cylinder-challenge.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-221-the-tiny-entrance-announcement.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-222-the-benchs-striped-bookend.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-223-the-soft-donut-negotiation.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-224-the-short-commute.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-225-the-cardboard-veranda.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-226-the-balls-discreet-opponent.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-227-the-folded-paw-portrait.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-228-the-tunnels-surprise-fringe.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-229-the-cushion-nose-dip.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-230-the-soft-star-inspection.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-231-the-scratch-mats-punctuation.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-232-the-blankets-open-invitation.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-233-the-quiet-garden-peek.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-234-the-soft-mouses-slow-escape.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-235-the-windows-fluffy-bracket.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-236-the-cushion-conference-recess.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-237-the-papers-soft-rustle.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-238-the-level-with-you-look.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-239-the-round-bed-overflow.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-240-the-peach-balls-shadow.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-241-the-cupboard-shaped-nook.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-242-the-tabbys-long-underline.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-243-the-fabric-ring-relay.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-244-the-little-elbow-room.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-245-the-scratchers-stripe-match.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-246-the-soft-cube-surprise.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-247-the-blankets-last-wrinkle.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-248-the-toys-floor-level-finale.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-249-the-open-boxs-morning-guest.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-250-the-sunset-seat-reservation.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-251-twig-committee.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-252-bath-overflow.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-253-millet-audit.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-254-branch-neighbours.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-255-earlier-appointment.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-256-landing-report.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-257-leaf-curiosity.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-258-mirrorless-duet.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-259-fluff-interval.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-260-upside-branch.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-261-sunbeam-edge.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-262-tidy-wing.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-263-perch-parade.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-264-seed-sideways.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-265-crest-forecast.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-266-floor-inspector.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-267-cheek-profile.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-268-paired-preening.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-269-low-wing-stretch.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-270-crest-in-shade.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-271-grain-inquiry.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-272-perch-gap.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-273-bath-brim.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-274-tail-comma.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-275-canary-concert.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-276-canary-cup.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-277-canary-seed.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-278-canary-branches.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-279-canary-feathers.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-280-canary-rest.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-281-finch-meeting.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-282-finch-bath.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-283-finch-soft-note.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-284-finch-grass.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-285-finch-double.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-286-finch-landing.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-287-grey-foot.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-288-senegal-branch.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-289-amazon-preen.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-290-ringneck-curve.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-291-hen-dust-spa.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-292-hen-leaf-file.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-293-hen-perch-row.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-294-hen-straw-dot.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-295-hen-walking-fluff.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-296-hen-side-portrait.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-297-hen-two-scratches.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-298-duck-ripple-trail.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-299-duck-water-comb.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-300-duck-bill-scan.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-301-duck-bank-pair.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-302-goose-grass-route.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-303-goose-shoulder-turn.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-304-pigeon-neck-glint.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-305-pigeon-bath-partners.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-306-robin-moss-seat.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-307-robin-winter-note.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-308-robin-leaf-landing.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-309-blue-tit-branch-end.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-310-blue-tit-leaf-look.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-311-cardinal-snow-dot.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-312-cardinal-warm-tone.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-313-woodpecker-trunk-route.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-314-woodpecker-bark-pause.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-315-wren-large-note.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-316-kingfisher-still-blue.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-317-puffin-orange-step.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-318-blackbird-lawn-pause.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-319-blackbird-leaf-turn.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-320-heron-long-pause.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-321-rabbit-hay-arch.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-322-rabbit-ear-forecast.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-323-rabbit-dig-tray.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-324-rabbit-two-rests.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-325-rabbit-nose-close.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-326-rabbit-step-over.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-327-rabbit-groom-paw.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-328-rabbit-grass-pair.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-329-rabbit-long-loaf.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-330-rabbit-chin-wood.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-331-rabbit-hop-turn.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-332-rabbit-lop-listen.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-333-rabbit-hay-ends.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-334-rabbit-shelter-peek.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-335-rabbit-companion-groom.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-336-guinea-hay-moustache.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-337-guinea-tunnel-pair.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-338-guinea-small-hop.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-339-guinea-nose-door.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-340-guinea-grass-line.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-341-guinea-rosette.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-342-guinea-double-hide.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-343-guinea-wide-nose.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-344-guinea-afternoon-rest.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-345-guinea-long-walk.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-346-hamster-night-door.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-347-hamster-paper-works.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-348-hamster-sand-tracks.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-349-hamster-cheek-profile.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-350-hamster-burrow-view.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-351-hamster-wheel-step.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-352-hamster-log-question.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-353-hamster-bed-pause.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-354-rat-bridge-check.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-355-rat-paw-wash.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-356-rat-two-noses.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-357-rat-climbing-angle.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-358-rat-forage-map.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-359-rat-hammock-company.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-360-rat-door-peek.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-361-ferret-tunnel-turn.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-362-ferret-soft-pair.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-363-ferret-paw-feint.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-364-ferret-box-edge.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-365-ferret-nose-close.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-366-horse-grass-curl.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-367-pony-wind-fringe.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-368-horse-two-shadows.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-369-horse-low-step.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-370-horse-whisker-light.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-371-pony-muddy-socks.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-372-horse-mutual-groom.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-373-horse-tail-sweep.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-374-donkey-ear-frame.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-375-donkey-pair-door.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-376-donkey-slow-turn.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-377-donkey-soft-muzzle.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-378-goat-platform-view.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-379-goat-beard-angle.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-380-goat-two-levels.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-381-goat-browse-pause.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-382-goat-path-step.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-383-sheep-wool-curl.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-384-sheep-parallel-graze.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-385-sheep-ear-pause.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-386-sheep-low-procession.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-387-pig-rooting-note.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-388-pig-mud-edge.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-389-pig-two-snouts.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-390-pig-straw-portrait.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-391-the-grass-has-time.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-392-turn-signal-optional.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-393-shade-with-a-doorstep.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-394-log-seating-plan.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-395-the-floating-comma.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-396-one-foot-at-a-time.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-397-the-branch-handshake.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-398-tail-punctuation.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-399-two-views-available.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-400-a-narrow-green-bridge.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-401-leaf-level-arrival.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-402-the-tail-got-there-first.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-403-sun-stripe.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-404-the-leafy-mouthful.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-405-long-route-around.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-406-rain-s-small-audience.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-407-footnote-in-green.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-408-leaf-hopping-interval.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-409-the-folded-awning.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-410-night-shift-tiny-desk.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-411-dragon-no-flames-required.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-412-the-shade-inspection.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-413-a-tongue-length-question.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-414-small-dragon-big-branch.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-415-reed-curtain.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-416-the-small-imaginary-passenger.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-417-ripple-signature.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-418-sun-on-the-ridges.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-419-a-tail-in-the-shallows.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-420-bank-side-mirror.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-421-attached-blanket.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-422-the-branch-elbow.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-423-a-nose-between-leaves.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-424-the-dangling-detail.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-425-the-pond-committee.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-426-grass-with-a-side-of-grass.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-427-the-shallow-water-haircut.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-428-room-beside-the-reed.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-429-the-horizon-appointment.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-430-sand-on-the-nose.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-431-the-shared-sun-patch.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-432-low-level-investigation.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-433-ears-before-entrance.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-434-dune-side-loaf.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-435-footprints-small-edition.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-436-twilight-outline.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-437-the-tree-s-soft-bracket.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-438-leaf-at-nose-height.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-439-one-excellent-foot.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-440-a-very-compact-nap.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-441-the-wide-entrance.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-442-grass-level-wander.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-443-ear-through-the-grass.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-444-rest-at-the-root.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-445-a-trunkful-of-splash.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-446-the-mud-hem.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-447-walking-in-the-big-shade.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-448-the-ear-shaped-breeze.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-449-top-shelf-lunch.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-450-legs-then-the-rest.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-451-the-folded-lookout.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-452-two-heights-of-company.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-453-stripes-at-the-waterline.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-454-the-dust-roll-finish.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-455-side-by-side-pattern.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-456-one-ear-in-the-frame.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-457-the-tail-parade.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-458-sun-facing-seats.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-459-branch-and-stripes.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-460-a-careful-little-landing.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-461-the-flexible-introduction.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-462-shallow-water-trousers.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-463-a-forest-sized-doorway.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-464-dappled-nap.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-465-the-hooked-tail-ending.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-466-whiskers-in-the-canopy.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-467-the-shaggy-branch-cushion.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-468-around-the-fork.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-469-the-nose-leads.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-470-tail-as-scenery.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-471-the-shaded-curl.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-472-crossing-the-light.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-473-the-stripe-reveal.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-474-leaf-level-company.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-475-the-long-reach.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-476-soft-rain-on-stripes.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-477-the-hollow-tree-window.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-478-paws-at-the-stream.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-479-a-branch-wide-balance.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-480-the-sleeping-mask.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-481-the-pebble-approach.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-482-whiskers-above-water.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-483-the-bank-side-pair.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-484-the-clean-curved-dive.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-485-luxury-interrupted.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-486-the-floating-lunch-tray.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-487-kelp-side-pause.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-488-whiskers-after-the-dive.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-489-two-drifting-outlines.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-490-eight-ways-around-a-stone.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-491-the-den-s-curved-doorway.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-492-suckers-in-a-row.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-493-a-sea-floor-flourish.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-494-the-meadow-from-above.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-495-flipper-shaped-sunlight.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-496-the-seagrass-mouthful.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-497-the-rock-s-round-cushion.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-498-a-nose-in-the-swell.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-499-transparent-traffic.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-amusing-animals-500-the-soft-circle.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-001-linen-rosemary.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-002-blue-white-lunch.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-003-amber-evening.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-004-tiny-round-table.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-005-mismatched-glass.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-006-citrus-breakfast.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-007-low-centerpiece.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-008-buffet-sideboard.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-009-quiet-place-cards.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-010-terrace-supper.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-011-brunch-small-checks.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-012-one-place.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-013-black-white-runner.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-014-berry-napkins.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-015-sofa-tray.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-016-family-table.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-017-child-friendly-places.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-018-picnic-at-table.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-019-soup-and-space.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-020-tea-tray.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-021-washable-placemats.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-022-cloth-without-trailing.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-023-separate-flowers.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-024-refill-station.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-025-serving-bowl-rehearsal.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-026-guest-preferences.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-027-clear-departure.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-028-quiet-morning-reset.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-029-short-round-table.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-030-table-for-making.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-031-speckled-stoneware.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-032-green-glass.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-033-patterned-rim.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-034-dark-table.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-035-timber-grain.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-036-small-cafe.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-037-book-evening.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-038-card-table.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-039-rainy-lunch.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-040-breakfast-return.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-041-plum-cream.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-041-spill-cloth.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-042-clay-cobalt.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-043-yellow-morning.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-044-lavender-grey.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-045-sage-white.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-046-oat-black.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-047-blush-relief.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-048-navy-dusk.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-049-coral-fold.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-050-copper-note.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-051-dessert-reset.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-052-serving-spoon-rest.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-053-bread-perimeter-clear.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-053-bread-perimeter.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-054-cloth-fold-storage.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-055-window-glare.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-056-trivet-footprint.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-057-easy-napkin-fold.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-058-pitcher-handle.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-059-small-plate-stack.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-060-care-before-cupboard.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-061.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-062.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-063.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-064.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-065.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-066.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-067.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-068.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-069.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-070.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-071.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-072.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-073.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-074.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-075.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-076.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-077.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-078.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-079.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-080.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-081-herb-edge.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-082-blue-horizon.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-083-open-door.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-084-shed-palette.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-085-wall-lunch.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-086-leaf-colour.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-087-early-hour.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-088-garden-counter.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-089-soft-stripe.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-090-autumn-border.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-091-napkin-basket.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-092-later-dessert.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-093-clear-contrast.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-094-quiet-sound.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-095-remnant-dish.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-095-window-glare.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-096-carafe-surface.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-097-indoor-alternative.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-098-easy-fold.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-098-seasoning-choice.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-099-actual-meal.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-dinner-table-100-setting-note.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-001-lemon-white-beans.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-002-tahini-cabbage.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-003-mushroom-miso-udon.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-004-carrot-lentil-salad.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-005-broccoli-pesto-pasta.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-006-golden-cauliflower.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-007-rosemary-pear-galette.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-008-citrus-semolina-cake.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-009-fennel-orange-salad.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-010-sweet-potato-tostadas.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-011-tomato-peach-toast.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-012-courgette-ribbons.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-013-crispy-gnocchi.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-014-aubergine-butter-beans.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-015-beetroot-labneh.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-016-corn-chowder.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-017-tomato-galette.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-018-apricot-yogurt-pots.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-019-cucumber-peanut-noodles.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-020-crushed-potatoes.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-021-tomato-red-lentil-soup.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-022-leek-white-bean-braise.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-023-squash-tahini-bowl.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-024-herbed-couscous.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-025-charred-pepper-orzo.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-026-mushroom-barley.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-027-pink-beet-hummus.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-028-pea-mint-dip.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-029-smoky-bean-dip.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-030-roasted-grape-crostini.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-031-orange-tofu-broccoli.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-032-spinach-chickpea-stew.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-033-braised-celery-lemon.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-033-fennel-orange-olive.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-034-cauliflower-caper-pasta.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-035-roasted-plum-oats.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-036-butter-bean-mash.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-037-green-bean-potato-salad.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-038-coconut-lentils.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-039-carrot-ginger-soup.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-040-apple-ricotta-toast.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-041-roasted-radish-lentils.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-042-pepper-chickpea-flatbread.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-043-roasted-parsnip-soup.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-044-tomato-polenta.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-045-pear-walnut-yogurt.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-046-broccoli-lemon-couscous.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-047-mushroom-toast.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-048-orange-carrot-slaw.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-049-aubergine-yogurt-dip.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-050-sweet-potato-lime-soup.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-051-feta-pepper-tray.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-052-pasta-peas-ricotta.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-053-roasted-celeriac.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-054-cabbage-apple-slaw.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-055-miso-roasted-carrots.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-056-banana-oat-pancakes.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-057-beans-roasted-garlic.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-058-strawberry-yogurt.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-059-squash-pasta-sage.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-060-cucumber-dill-yogurt.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-061-corn-avocado-salad.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-062-lemon-baked-potatoes.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-063-white-bean-cucumber-salad.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-064-pea-potato-soup.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-065-roasted-apples.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-066-sesame-cabbage-noodles.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-067-beet-orange-salad.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-068-tomato-chickpea-pasta.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-069-spinach-butter-beans.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-070-peach-almond-crumble.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-071-spinach-feta-frittata.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-072-blueberry-oat-muffins.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-073-cheddar-chive-scones.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-074-carrot-oat-pancakes.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-075-tomato-mozzarella-toast.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-076-baked-berry-oats.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-077-mushroom-frittata.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-078-lemon-yogurt-pancakes.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-079-apple-cinnamon-porridge.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-080-roasted-tomato-egg.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-081-one-pan-two-stages.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-082-drain-before-dress.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-083-canned-bean-open-life.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-084-rice-small-portions.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-085-scale-first-baking.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-086-salad-crunch-last.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-087-citrus-final-taste.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-088-hot-soup-blending.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-089-leftover-label.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-090-opened-pack-priority.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-091-recipe-before-board.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-092-grate-small-portion.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-093-herb-finish.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-094-soft-fruit-bake.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-095-pack-separate.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-096-sauce-by-spoon.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-097-sheet-space.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-098-second-taste.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-099-freezer-portion.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-food-100-favourite-method-note.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-001.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-002.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-003.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-004.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-005.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-006.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-007.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-008.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-009.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-010.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-011.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-012.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-013.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-014.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-015.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-016.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-017.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-018.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-019.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-020.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-021.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-022.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-023.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-024.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-025.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-026.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-027.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-028.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-029.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-030.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-031.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-032.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-033.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-034.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-035.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-036.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-037.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-038.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-039.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-040.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-041.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-042.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-043.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-044.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-045.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-046.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-047.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-048.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-049.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-050.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-051.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-052.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-053.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-054.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-055.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-056.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-057.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-058.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-059.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-060.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-061.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-062.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-063.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-064.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-065.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-066.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-067.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-068.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-069.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-070.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-071.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-072.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-073.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-074.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-075.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-076.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-077.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-078.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-079.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-080.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-081.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-082.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-083.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-084.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-085.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-086.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-087.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-088.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-089.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-090.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-091.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-092.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-093.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-094.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-095.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-096.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-097.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-098.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-099.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-garden-garden-100.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-001.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-002.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-003.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-004.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-005.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-006.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-007.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-008.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-009.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-010.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-011.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-012.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-013.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-014.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-015.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-016.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-017.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-018.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-019.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-020.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-021.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-022.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-023.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-024.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-025.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-026.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-027.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-028.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-029.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-030.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-031.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-032.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-033.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-034.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-035.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-036.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-037.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-038.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-039.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-040.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-041.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-042.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-043.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-044.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-045.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-046.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-047.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-048.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-049.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-050.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-051.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-052.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-053.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-054.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-055.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-056.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-057.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-058.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-059.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-060.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-061.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-062.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-063.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-064.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-065.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-066.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-067.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-068.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-069.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-070.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-071.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-072.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-073.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-074.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-075.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-076.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-077.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-078.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-079.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-080.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-081.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-082.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-083.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-084.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-085.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-086.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-087.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-088.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-089.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-090.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-091.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-092.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-093.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-094.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-095.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-096.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-097.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-098.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-099.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/lifestyle-home-decor-100.webp": {
    "width": 1024,
    "height": 1536,
    "widths": [160, 640, 1024]
  },
  "/assets/pack-ancient-egypt.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/pack-ancient-india.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/pack-ancient-wonders.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/pack-astrology.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/pack-astronomy.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/pack-biology.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/pack-budget-recipes.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/pack-chemistry.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/pack-classical-greece.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/pack-coding.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/pack-design-photography.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/pack-earth-climate.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/pack-engineering.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/pack-europe-by-rail.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/pack-history-arabian-worlds.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/pack-history-australia.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/pack-history-brazil.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/pack-history-byzantium.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/pack-history-canada.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/pack-history-cree.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/pack-history-england-britain.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/pack-history-ethiopia.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/pack-history-france.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/pack-history-gaul.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/pack-history-georgia.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/pack-history-german-worlds.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/pack-history-gran-colombia.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/pack-history-hungary.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/pack-history-inca.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/pack-history-japan.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/pack-history-khmer.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/pack-history-kongo.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/pack-history-korean-worlds.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/pack-history-macedon.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/pack-history-majapahit.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/pack-history-mali.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/pack-history-maori.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/pack-history-mapuche.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/pack-history-mexica.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/pack-history-mongolia.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/pack-history-netherlands.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/pack-history-norway.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/pack-history-nubia-kush.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/pack-history-ottoman.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/pack-history-persian-worlds.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/pack-history-phoenician-worlds.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/pack-history-poland.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/pack-history-portugal.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/pack-history-russia.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/pack-history-scotland.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/pack-history-scythian-worlds.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/pack-history-spain.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/pack-history-sweden.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/pack-history-united-states.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/pack-history-vietnam.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/pack-history-zulu.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/pack-imperial-china.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/pack-maths.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/pack-maya-cities.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/pack-mesopotamia.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/pack-new-seven-wonders.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/pack-physics.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/pack-roman-empire.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/pack-study-lab.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/pack-world-kitchens.webp": { "width": 960, "height": 1200, "widths": [160, 640, 960] },
  "/assets/pottery.png": { "width": 1448, "height": 1086, "widths": [160, 640, 1280] },
  "/assets/social-connections-guide-v1.png": {
    "width": 1536,
    "height": 1024,
    "widths": [160, 640, 1536]
  },
  "/assets/starter-breakfast.webp": { "width": 1024, "height": 1536, "widths": [160, 640, 1024] },
  "/assets/starter-chicago.webp": { "width": 1280, "height": 354, "widths": [160, 640, 1280] },
  "/assets/starter-earthrise.webp": { "width": 1224, "height": 1280, "widths": [160, 640, 1224] },
  "/assets/starter-food.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/starter-market.webp": { "width": 1024, "height": 1024, "widths": [160, 640, 1024] },
  "/assets/starter-mars.webp": { "width": 1600, "height": 449, "widths": [160, 640, 1600] },
  "/assets/travel-acropolis.webp": { "width": 960, "height": 640, "widths": [160, 640, 960] },
  "/assets/travel-cotswolds.webp": { "width": 960, "height": 640, "widths": [160, 640, 960] },
  "/assets/travel-dolomites.webp": { "width": 960, "height": 640, "widths": [160, 640, 960] },
  "/assets/travel-fiordland.webp": { "width": 960, "height": 640, "widths": [160, 640, 960] },
  "/assets/travel-fujisan.webp": { "width": 960, "height": 640, "widths": [160, 640, 960] },
  "/assets/travel-galapagos.webp": { "width": 960, "height": 640, "widths": [160, 640, 960] },
  "/assets/travel-grand-canyon.webp": { "width": 960, "height": 640, "widths": [160, 640, 960] },
  "/assets/travel-great-barrier-reef.webp": {
    "width": 960,
    "height": 640,
    "widths": [160, 640, 960]
  },
  "/assets/travel-ha-long-cat-ba.webp": { "width": 960, "height": 640, "widths": [160, 640, 960] },
  "/assets/travel-iguazu.webp": { "width": 960, "height": 640, "widths": [160, 640, 960] },
  "/assets/travel-istanbul-water.webp": { "width": 960, "height": 640, "widths": [160, 640, 960] },
  "/assets/travel-kyoto-gardens.webp": { "width": 960, "height": 640, "widths": [160, 640, 960] },
  "/assets/travel-lake-district.webp": { "width": 960, "height": 640, "widths": [160, 640, 960] },
  "/assets/travel-mexico-city-water.webp": {
    "width": 960,
    "height": 640,
    "widths": [160, 640, 960]
  },
  "/assets/travel-paris-seine.webp": { "width": 960, "height": 640, "widths": [160, 640, 960] },
  "/assets/travel-plitvice.webp": { "width": 960, "height": 640, "widths": [160, 640, 960] },
  "/assets/travel-rome-layers.webp": { "width": 960, "height": 640, "widths": [160, 640, 960] },
  "/assets/travel-statue-liberty.webp": { "width": 960, "height": 640, "widths": [160, 640, 960] },
  "/assets/travel-table-mountain.webp": { "width": 960, "height": 640, "widths": [160, 640, 960] },
  "/assets/travel-taj-mahal.webp": { "width": 960, "height": 640, "widths": [160, 640, 960] },
  "/assets/travel-tokyo-asakusa.webp": { "width": 960, "height": 640, "widths": [160, 640, 960] },
  "/assets/travel-uluru.webp": { "width": 960, "height": 640, "widths": [160, 640, 960] },
  "/assets/travel-victoria-falls.webp": { "width": 960, "height": 640, "widths": [160, 640, 960] },
  "/assets/travel-yellowstone.webp": { "width": 960, "height": 640, "widths": [160, 640, 960] },
  "/assets/webb-cliffs.webp": { "width": 1600, "height": 554, "widths": [160, 640, 1600] },
  "/assets/webb-pillars.webp": { "width": 1155, "height": 2001, "widths": [160, 640, 1155] },
  "/assets/wonder-artemis.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] },
  "/assets/wonder-colossus-of-rhodes.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/wonder-hanging-gardens-traditions.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/wonder-new-wonders-chichen-itza.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/wonder-new-wonders-christ-redeemer.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/wonder-new-wonders-colosseum.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/wonder-new-wonders-great-wall.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/wonder-new-wonders-machu-picchu.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/wonder-new-wonders-petra.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/wonder-new-wonders-taj-mahal.webp": {
    "width": 960,
    "height": 1200,
    "widths": [160, 640, 960]
  },
  "/assets/wonder-pharos.webp": { "width": 1280, "height": 853, "widths": [160, 640, 1280] }
}
